"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

require("./index.css");

var getPath = function (name, props) {
  switch (name) {
    case 'add':
    case 'circle-plus':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M25.333 18.667h-6.666v6.666h-5.334v-6.666H6.667v-5.334h7.11V6.667h4.89v6.666h6.666v5.334zM16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M16 0c8.836 0 16 7.164 16 16s-7.164 16-16 16S0 24.836 0 16 7.164 0 16 0zm0 2.667C8.648 2.667 2.667 8.648 2.667 16S8.648 29.333 16 29.333 29.333 23.352 29.333 16 23.352 2.667 16 2.667zm1.333 4v8h8v2.666h-8v8h-2.666v-8h-8v-2.666h8v-8h2.666z"
        }), void 0)]
      }, void 0);

    case 'alert':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "m31.742 27.158c0.73399 1.2621-0.184 2.8417-1.654 2.8417h-28.176c-1.47 0-2.388-1.5796-1.654-2.8417l14.088-24.21c0.73599-1.2641 2.572-1.2641 3.308 0l14.088 24.21z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill variant",
          d: "m16 22c1.1037 0 2 0.89634 2 2 0 1.1058-0.89634 2-2 2s-2-0.89424-2-2c0-1.1037 0.89634-2 2-2zm2-12v8h-3.9999v-8h3.9999z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M31.742 27.158C32.476 28.42 31.558 30 30.088 30H1.912C.442 30-.476 28.42.258 27.158l14.088-24.21c.736-1.264 2.572-1.264 3.308 0l14.088 24.21zM16 4.082L2.082 28h27.836L16 4.082zM16 24a1 1 0 110-2 1 1 0 010 2zm-1-4.997v-6.006c0-.544.448-.997 1-.997.556 0 1 .446 1 .997v6.006c0 .544-.448.997-1 .997-.556 0-1-.446-1-.997z"
        }), void 0)]
      }, void 0);

    case 'analysis':
    case 'revenue':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M9 17.333V32H1V17.333h8zm10.667-8V32h-8V9.333h8zM30.333 0v32h-8V0h8z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M31.417 0v32H.75V17.333h9.333v-8h9.334V0h12zm-12 12H12.75v17.333h6.667V12zm-9.334 8H3.417v9.333h6.666V20zM28.75 2.667h-6.667v26.666h6.667V2.667z"
        }), void 0)]
      }, void 0);

    case 'arrow-right':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M24.343 14l-7.9-7.9a2 2 0 112.83-2.828L32 16 19.272 28.728a2 2 0 01-2.828-2.829l7.9-7.899H2a2 2 0 110-4h22.343z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M28.172 15L17.15 3.98a1 1 0 111.414-1.415L32 16 18.565 29.435a1 1 0 01-1.414-1.414L28.17 17H1a1 1 0 010-2h27.172z"
        }), void 0)]
      }, void 0);

    case 'arrow-down':
    case 'downtrend':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M16,4 L32,4 L16,28 L0,4 L16,4 Z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M16,4 L32,28 L0,28 L16,4 Z M16,7.60555128 L3.73703418,26 L28.2629658,26 L16,7.60555128 Z",
          transform: "translate(16.000000, 16.000000) scale(1, -1) translate(-16.000000, -16.000000)"
        }), void 0)]
      }, void 0);

    case 'arrow-up':
    case 'uptrend':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M16,4 L32,28 L16,28 L0,28 L16,4 Z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M16,4 L32,28 L0,28 L16,4 Z M16,7.60555128 L3.73703418,26 L28.2629658,26 L16,7.60555128 Z"
        }), void 0)]
      }, void 0);

    case 'arrow-up-down':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M12 0l7 7.008L17.554 8.5 13 3.94v16.118l4.554-4.558L19 16.992 12 24l-7-7.008L6.446 15.5 11 20.058V3.94L6.446 8.5 5 7.008z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M12 0l7 7.008L17.554 8.5 13 3.94v16.118l4.554-4.558L19 16.992 12 24l-7-7.008L6.446 15.5 11 20.058V3.94L6.446 8.5 5 7.008z"
        }), void 0)]
      }, void 0);

    case 'asc':
    case 'down-chevron':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M16,26.242245 L31.1210183,11.1212266 C32.2929939,9.95058436 32.2929939,8.05062395 31.1210183,6.87864836 C29.9490427,5.70800608 28.0504156,5.70800608 26.87844,6.87864836 L16,17.7584217 L5.12155997,6.87864836 C4.53490552,6.29332722 3.76825483,6 3.00027083,6 C2.23228683,6 1.46430283,6.29332722 0.878981688,6.87864836 C-0.292993896,8.05062395 -0.292993896,9.95058436 0.878981688,11.1212266 L16,26.242245 Z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M30.2923689,7.58299386 L15.9993333,21.8760294 L1.70763109,7.58299386 C1.31697256,7.19233533 0.683652424,7.19233533 0.292993896,7.58299386 C-0.097664632,7.97365239 -0.097664632,8.60697252 0.292993896,8.99763105 L15.9993333,24.7039705 L31.7070061,8.99763105 C32.0976646,8.60697252 32.0976646,7.97365239 31.7070061,7.58299386 C31.3163476,7.19233533 30.6830274,7.19233533 30.2923689,7.58299386"
        }), void 0)]
      }, void 0);

    case 'askquestion':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M14,0 C19.5226667,0 24,4.47733333 24,10 L24,10 L24,11 C24,16.5226667 19.5226667,21 14,21 L14,21 L10,21 C9.40533333,21 8.82366667,20.945 8.25733333,20.8456667 L8.25733333,20.8456667 L3,24 L3,18.1386667 C1.14933333,16.324 0,13.797 0,11 L0,11 L0,10 C0,4.47733333 4.47733333,0 10,0 L10,0 Z M13.2863333,14.1563333 L10.7556667,14.1563333 L10.7556667,16.6023333 L13.2863333,16.6023333 L13.2863333,14.1563333 Z M11.8053333,4 C10.8346667,4 10.0166667,4.21466667 9.351,4.64333333 C8.29566667,5.315 7.73433333,6.45466667 7.66666667,8.06266667 L7.66666667,8.06266667 L10.1126667,8.06266667 C10.1126667,7.594 10.249,7.143 10.522,6.70833333 C10.795,6.274 11.258,6.05666667 11.911,6.05666667 C12.575,6.05666667 13.0326667,6.233 13.2833333,6.58566667 C13.5336667,6.93833333 13.6586667,7.32933333 13.6586667,7.758 C13.6586667,8.13033333 13.5463333,8.47166667 13.3213333,8.782 C13.1976667,8.96266667 13.0343333,9.129 12.832,9.28133333 L12.832,9.28133333 L12.2156667,9.76366667 C11.6083333,10.2376667 11.2313333,10.6566667 11.085,11.0206667 C10.9386667,11.3846667 10.8486667,12.0433333 10.815,12.997 L10.815,12.997 L13.1086667,12.997 C13.1143333,12.5453333 13.151,12.2126667 13.2183333,11.998 C13.3253333,11.6596667 13.542,11.3633333 13.8683333,11.1093333 L13.8683333,11.1093333 L14.4676667,10.644 C15.0753333,10.17 15.486,9.78066667 15.7,9.476 C16.0656667,8.97366667 16.2486667,8.356 16.2486667,7.62233333 C16.2486667,6.42633333 15.8266667,5.52366667 14.9833333,4.914 C14.1396667,4.30466667 13.0803333,4 11.8053333,4 Z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M14,0 C19.5226667,0 24,4.47733333 24,10 L24,10 L24,11 C24,16.5226667 19.5226667,21 14,21 L14,21 L10,21 C9.40533333,21 8.82366667,20.945 8.25733333,20.8456667 L8.25733333,20.8456667 L3,24 L3,18.1386667 C1.14933333,16.324 0,13.797 0,11 L0,11 L0,10 C0,4.47733333 4.47733333,0 10,0 L10,0 Z M14,2 L10,2 C5.589,2 2,5.589 2,10 L2,10 L2,11 C2,13.1646667 2.85266667,15.193 4.40033333,16.711 L4.40033333,16.711 L5,17.2986667 L5,20.4676667 L7.22866667,19.1306667 L7.86866667,18.7463333 L8.604,18.8756667 C9.07266667,18.9583333 9.54233333,19 10,19 L10,19 L14,19 C18.4113333,19 22,15.411 22,11 L22,11 L22,10 C22,5.589 18.4113333,2 14,2 L14,2 Z M13.367,14.1626667 L13.367,16.6086667 L10.8363333,16.6086667 L10.8363333,14.1626667 L13.367,14.1626667 Z M11.8856667,4.00666667 C13.1606667,4.00666667 14.2203333,4.31133333 15.0636667,4.92066667 C15.9073333,5.53 16.329,6.43266667 16.329,7.629 C16.329,8.36233333 16.146,8.98 15.7803333,9.48233333 C15.5666667,9.787 15.156,10.1763333 14.548,10.6503333 L13.949,11.116 C13.6223333,11.3696667 13.4056667,11.666 13.2986667,12.0046667 C13.2313333,12.219 13.1946667,12.5516667 13.189,13.0033333 L10.8956667,13.0033333 C10.9293333,12.0496667 11.0193333,11.391 11.1656667,11.027 C11.312,10.663 11.6886667,10.244 12.2963333,9.77033333 L12.9123333,9.28766667 C13.1146667,9.13533333 13.278,8.969 13.4016667,8.78833333 C13.6266667,8.47833333 13.7393333,8.13666667 13.7393333,7.76433333 C13.7393333,7.33566667 13.614,6.94466667 13.3636667,6.592 C13.113,6.23966667 12.6556667,6.063 11.9916667,6.063 C11.3386667,6.063 10.8753333,6.28033333 10.6026667,6.715 C10.3293333,7.14933333 10.193,7.60066667 10.193,8.069 L7.747,8.069 C7.81466667,6.461 8.376,5.32133333 9.43133333,4.64966667 C10.097,4.221 10.9153333,4.00666667 11.8856667,4.00666667 Z"
        }), void 0)]
      }, void 0);

    case 'avatar':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M27.186 27.44l.063.06A15.947 15.947 0 0116 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16c0 4.483-1.844 8.535-4.814 11.44zM8.184 25.106A15.927 15.927 0 0116.124 23c2.828 0 5.485.734 7.79 2.02A11.971 11.971 0 0028 16c0-6.627-5.373-12-12-12S4 9.373 4 16c0 3.642 1.623 6.905 4.184 9.106zM16 19a5 5 0 110-10 5 5 0 010 10z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M8.013 27.5A13.936 13.936 0 0016 30c2.969 0 5.721-.924 7.987-2.5A13.936 13.936 0 0016 25c-2.969 0-5.721.924-7.987 2.5zm-1.608-1.305A15.93 15.93 0 0116 23c3.6 0 6.922 1.189 9.595 3.195A13.961 13.961 0 0030 16c0-7.732-6.268-14-14-14S2 8.268 2 16c0 4.019 1.693 7.642 4.405 10.195zM16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm0-13a5 5 0 110-10 5 5 0 010 10zm0-2a3 3 0 100-6 3 3 0 000 6z"
        }), void 0)]
      }, void 0);

    case 'bar-chart':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M24 32V8h8v24h-8zM0 32V16h8v16H0zm12 0V0h8v32h-8z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M10 0h12v8h10v24H0V16h10V0zM2 30h8V18H2v12zm20 0h8V10h-8v20zM12 2v28h8V2h-8z"
        }), void 0)]
      }, void 0);

    case 'bin':
    case 'delete':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M27.7 10.667L25.91 27.73C25.606 30.165 23.573 32 21.18 32h-10.73c-2.444 0-4.481-1.88-4.74-4.372L4.3 10.667h23.4zm0-5.334c.718 0 1.3.597 1.3 1.334C29 7.403 28.418 8 27.7 8H4.3C3.582 8 3 7.403 3 6.667c0-.737.582-1.334 1.3-1.334h23.4zM22.5 0c.718 0 1.3.597 1.3 1.333 0 .737-.582 1.334-1.3 1.334h-13c-.718 0-1.3-.597-1.3-1.334C8.2.597 8.782 0 9.5 0h13z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M6.9 10.667l1.396 16.68c.118 1.132 1.044 1.986 2.155 1.986h10.73c1.087 0 2.012-.834 2.15-1.94L25.1 10.666h2.6L25.91 27.73C25.606 30.164 23.574 32 21.18 32h-10.73c-2.444 0-4.482-1.88-4.74-4.372L4.3 10.667h2.6zm20.8-5.334c.718 0 1.3.597 1.3 1.334C29 7.403 28.418 8 27.7 8H4.3C3.582 8 3 7.403 3 6.667c0-.737.582-1.334 1.3-1.334h23.4zM22.5 0c.718 0 1.3.597 1.3 1.333 0 .737-.582 1.334-1.3 1.334h-13c-.718 0-1.3-.597-1.3-1.334C8.2.597 8.782 0 9.5 0h13z"
        }), void 0)]
      }, void 0);

    case 'delete-alt':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M7.01030928,22.6 L7.91163476,62.4 C8.01178203,65.1 9.11340206,67.4 10.8159057,69.2 C11.2164948,69.6 11.7172312,70 12.2179676,70.4 C13.2194404,71.1 14.4212077,71.6 15.7231222,71.8 C16.3240059,71.9 17.0250368,72 17.6259205,72 L50.173785,72 C52.8777614,72 55.281296,70.9 56.9837997,69.2 C58.7864507,67.5 59.8880707,65.1 59.8880707,62.4 L60.7893962,22.6 L7.01030928,22.6 L7.01030928,22.6 Z M63.3932253,4.5 L51.0751105,4.5 C51.0751105,2 49.0721649,0 46.5684831,0 L21.3313697,0 C18.8276878,0 16.8247423,2 16.8247423,4.5 L4.50662739,4.5 C2.00294551,4.5 0,6.5 0,9 C0,11.5 2.00294551,13.5 4.50662739,13.5 L63.4933726,13.5 C65.9970545,13.5 68,11.5 68,9 C67.8998527,6.5 65.8969072,4.5 63.3932253,4.5 Z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M53.5,62.0383562 C53.4,64.8 51.1,67.0684932 48.2,67.0684932 L15.7,67.0684932 C12.9,67.0684932 10.5,64.8 10.4,62.0383562 L9.6,22.8821918 L5.1,22.8821918 L6,62.0383562 C6.1,67.2657534 10.4,71.5068493 15.8,71.5068493 L48.3,71.5068493 C53.6,71.5068493 57.9,67.3643836 58.1,62.0383562 L58.9,22.7835616 L54.4,22.7835616 L53.5,62.0383562 Z M61.4,9.36986301 L2.6,9.36986301 C1.4,9.36986301 0.3,10.3561644 0.3,11.6383562 C0.3,12.9205479 1.3,13.9068493 2.6,13.9068493 L61.4,13.9068493 C62.6,13.9068493 63.7,12.9205479 63.7,11.6383562 C63.7,10.3561644 62.7,9.36986301 61.4,9.36986301 Z M44.6,4.93150685 C45.8,4.93150685 46.9,3.94520548 46.9,2.6630137 C46.9,1.38082192 45.9,0.394520548 44.6,0.394520548 L19.4,0.394520548 C18.2,0.394520548 17.1,1.38082192 17.1,2.6630137 C17.1,3.94520548 18.1,4.93150685 19.4,4.93150685 L44.6,4.93150685 Z"
        }), void 0)]
      }, void 0);

    case 'download':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M14.667 8v13.504l-4.634-4.633c-.456-.456-1.182-.566-1.716-.205a1.334 1.334 0 00-.205 2.054L16 26.608l7.888-7.888a1.334 1.334 0 00-.205-2.054c-.534-.361-1.26-.25-1.716.205l-4.634 4.633V8H32v21.333A2.667 2.667 0 0129.333 32H2.667A2.667 2.667 0 010 29.333V8h14.667zm2.666-8v8h-2.666V0h2.666z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M25 29.333V32H7v-2.667h18zM17.286 0v17.06l4.502-4.67a1.253 1.253 0 011.818 0c.503.521.503 1.366 0 1.886L16 22.164l-7.606-7.888a1.368 1.368 0 010-1.885 1.253 1.253 0 011.818 0l4.502 4.669V0h2.572z"
        }), void 0)]
      }, void 0);

    case 'download-alt':
      return (0, jsx_runtime_1.jsxs)("g", __assign({
        transform: "translate(16.000000, 0.000000)"
      }, {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M20,54 L1.33333333,35.1 C-0.444444444,33.3 -0.444444444,30.5 1.33333333,28.7 C3.11111111,26.9 5.87654321,26.9 7.65432099,28.7 L15.5555556,36.7 L15.5555556,0 L24.4444444,0 L24.4444444,36.8 L32.345679,28.8 C34.1234568,27 36.8888889,27 38.6666667,28.8 C40.4444444,30.6 40.4444444,33.4 38.6666667,35.2 L20,54 Z M0.049382716,72 L0.049382716,63 L39.9506173,63 L39.9506173,72 L0.049382716,72 Z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M20,50.8 L2.87128713,33.5 C1.98019802,32.6 1.98019802,31.2 2.87128713,30.3 C3.76237624,29.4 5.14851485,29.4 6.03960396,30.3 L17.8217822,42.2 L17.8217822,0 L22.2772277,0 L22.2772277,42.2 L34.0594059,30.3 C34.950495,29.4 36.3366337,29.4 37.2277228,30.3 C38.1188119,31.2 38.1188119,32.6 37.2277228,33.5 L20,50.8 Z M0,72 L0,67.5 L40,67.5 L40,72 L0,72 Z"
        }), void 0)]
      }), void 0);

    case 'calendar':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M30 13v16.286A2.721 2.721 0 0127.273 32H2.727A2.721 2.721 0 010 29.286V13h30zm-5 8h-6v6h6v-6zM8.182 0v4.125h13.636V0h2.727v4.125H30V11H0V4.125h5.455V0h2.727z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M9.182 0v4h13.636V0h2.727v4H31v25.333C31 30.806 29.779 32 28.273 32H3.727C2.221 32 1 30.806 1 29.333V4h5.455V0h2.727zm19.09 13.333H3.728v16h24.546v-16zm-4.09 8v4H20.09v-4h4.09zm4.09-14.666H3.728v4h24.546v-4z"
        }), void 0)]
      }, void 0);

    case 'charts':
    case 'table-data':
    case 'table':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M14.667 23.652V32H5.333C2.388 32 0 29.508 0 26.435v-2.783h14.667zm17.333 0v2.783C32 29.508 29.612 32 26.667 32h-9.334v-8.348H32zM14.667 11.13v9.74H0v-9.74h14.667zm17.333 0v9.74H17.333v-9.74H32zM26.667 0C29.612 0 32 2.492 32 5.565v2.783H17.333V0h9.334zm-12 0v8.348H0V5.565C0 2.492 2.388 0 5.333 0h9.334z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M26.667 29.217h-9.334v-6.956h12v4.174c0 1.534-1.196 2.782-2.666 2.782zm-24-2.782V22.26h12v6.956H5.333c-1.47 0-2.666-1.248-2.666-2.782zm12-13.913v6.956h-12v-6.956h12zm14.666 0v6.956h-12v-6.956h12zm-14.666-9.74V9.74h-12V5.565c0-1.534 1.196-2.782 2.666-2.782h9.334zm14.666 2.783V9.74h-12V2.783h9.334c1.47 0 2.666 1.248 2.666 2.782zM26.667 0H5.333C2.388 0 0 2.492 0 5.565v20.87C0 29.508 2.388 32 5.333 32h21.334C29.612 32 32 29.508 32 26.435V5.565C32 2.492 29.612 0 26.667 0z"
        }), void 0)]
      }, void 0);

    case 'check':
    case 'circle-checkmark':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M16 0c8.836 0 16 7.163 16 16 0 8.836-7.164 16-16 16-8.837 0-16-7.164-16-16C0 7.163 7.163 0 16 0zm-1.983 22.838l10.811-10.85-2.833-2.824-7.983 8.011-3.196-3.193-2.828 2.828 6.03 6.028z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M16 0c8.837 0 16 7.164 16 16s-7.163 16-16 16C7.164 32 0 24.836 0 16S7.164 0 16 0zm0 30c7.72 0 14-6.28 14-14S23.72 2 16 2 2 8.28 2 16s6.28 14 14 14zm-1.987-11.408l7.984-8.014 1.416 1.412-9.398 9.432-4.612-4.613 1.413-1.413 3.197 3.196z"
        }), void 0)]
      }, void 0);

    case 'circle-cross':
    case 'circle-delete':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M15.5355339,18.363961 L12,14.8284271 L8.46446609,18.363961 L5.63603897,15.5355339 L9.17157288,12 L5.63603897,8.46446609 L8.46446609,5.63603897 L12.2357023,9.40727514 L15.7712362,5.87174123 L18.363961,8.46446609 L14.8284271,12 L18.363961,15.5355339 L15.5355339,18.363961 Z M12,0 C5.37266667,0 0,5.37266667 0,12 C0,18.6273333 5.37266667,24 12,24 C18.6273333,24 24,18.6273333 24,12 C24,5.37266667 18.6273333,0 12,0 L12,0 Z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M12,0 C18.6273333,0 24,5.37266667 24,12 C24,18.6273333 18.6273333,24 12,24 C5.37266667,24 0,18.6273333 0,12 C0,5.37266667 5.37266667,0 12,0 Z M12,2 C6.486,2 2,6.486 2,12 C2,17.514 6.486,22 12,22 C17.514,22 22,17.514 22,12 C22,6.486 17.514,2 12,2 Z M16.2426407,6.34314575 L17.6568542,7.75735931 L13.4142136,12 L17.6568542,16.2426407 L16.2426407,17.6568542 L12,13.4142136 L7.75735931,17.6568542 L6.34314575,16.2426407 L10.5857864,12 L6.34314575,7.75735931 L7.75735931,6.34314575 L12,10.5857864 L16.2426407,6.34314575 Z"
        }), void 0)]
      }, void 0);

    case 'check-basic':
    case 'checkmark':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M27.7911111 4 11.3466667 20.4444444 4.20888889 13.28 0 17.4977778 11.3644444 28.8888889 32 8.21777778z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M30.56 5.28888889 10.9066667 24.9422222 1.44 15.4755556 0 16.9155556 10.9066667 27.8222222 32 6.72888889z"
        }), void 0)]
      }, void 0);

    case 'collapse':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M0.586,0.586 C1.367,-0.195333333 2.63333333,-0.195333333 3.414,0.586 L3.414,0.586 L10.8286667,8 L3.414,15.414 C2.63333333,16.1953333 1.367,16.1953333 0.586,15.414 C-0.195333333,14.6333333 -0.195333333,13.367 0.586,12.586 L0.586,12.586 L5.17166667,8 L0.586,3.414 C-0.195333333,2.63333333 -0.195333333,1.367 0.586,0.586 Z M20.5861333,0.586 C21.3668,-0.195333333 22.6331333,-0.195333333 23.4141333,0.586 C24.1954667,1.367 24.1954667,2.63333333 23.4141333,3.414 L23.4141333,3.414 L18.8284667,8 L23.4141333,12.586 C24.1954667,13.367 24.1954667,14.6333333 23.4141333,15.414 C22.6331333,16.1953333 21.3668,16.1953333 20.5861333,15.414 L20.5861333,15.414 L13.1714667,8 Z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M0.293,0.293 C0.683666667,-0.0976666667 1.31633333,-0.0976666667 1.707,0.293 L1.707,0.293 L9.414,8 L1.707,15.707 C1.51166667,15.9023333 1.256,16 1,16 C0.744,16 0.488333333,15.9023333 0.293,15.707 C-0.0976666667,15.3166667 -0.0976666667,14.6833333 0.293,14.293 L0.293,14.293 L6.586,8 L0.293,1.707 C-0.0976666667,1.31666667 -0.0976666667,0.683333333 0.293,0.293 Z M23.707,0.293 C24.0976667,0.683333333 24.0976667,1.31666667 23.707,1.707 L17.414,8 L23.707,14.293 C24.0976667,14.6833333 24.0976667,15.3166667 23.707,15.707 C23.5116667,15.9023333 23.256,16 23,16 C22.744,16 22.4883333,15.9023333 22.293,15.707 L14.586,8 L22.293,0.293 C22.6836667,-0.0976666667 23.3163333,-0.0976666667 23.707,0.293 Z"
        }), void 0)]
      }, void 0);

    case 'comment-bubble':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M18 0h-4C6.267 0 0 6.328 0 14.137c0 3.815 1.467 7.226 3.911 9.784V32l6.445-4.219c1.155.314 2.4.494 3.644.494h4c7.733 0 14-6.328 14-14.138C32 6.328 25.733 0 18 0"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M18 0h-4C6.267 0 0 6.328 0 14.137c0 3.815 1.467 7.226 3.911 9.784V32l6.445-4.219c1.155.314 2.4.494 3.644.494h4c7.733 0 14-6.328 14-14.138C32 6.328 25.733 0 18 0"
        }), void 0)]
      }, void 0);

    case 'comment-check':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M18 0h-4C6.267 0 0 6.328 0 14.137c0 3.815 1.467 7.226 3.911 9.784V32l6.445-4.219c1.155.314 2.4.494 3.644.494h4c7.733 0 14-6.328 14-14.138C32 6.328 25.733 0 18 0"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "icon-white",
          d: "M14.37 21L24 11.478 21.477 9l-7.111 7.03-2.847-2.802L9 15.71 14.371 21z"
        }), void 0)]
      }, void 0);

    case 'comment-chevron':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M18 0h-4C6.267 0 0 6.328 0 14.137c0 3.815 1.467 7.226 3.911 9.784V32l6.445-4.219c1.155.314 2.4.494 3.644.494h4c7.733 0 14-6.328 14-14.138C32 6.328 25.733 0 18 0"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "icon-white",
          d: "M15.52 20.615L22.241 14 15.52 7.385a1.349 1.349 0 00-1.886 0 1.298 1.298 0 000 1.856L18.47 14l-4.837 4.76a1.3 1.3 0 000 1.855 1.349 1.349 0 001.886 0"
        }), void 0)]
      }, void 0);

    case 'comment-plus':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M18 0h-4C6.267 0 0 6.328 0 14.137c0 3.815 1.467 7.226 3.911 9.784V32l6.445-4.219c1.155.314 2.4.494 3.644.494h4c7.733 0 14-6.328 14-14.138C32 6.328 25.733 0 18 0"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "icon-white",
          d: "M17.877 20v-4.729H23v-2.542h-5.123V8h-2.754v4.729H10v2.542h5.123V20z"
        }), void 0)]
      }, void 0);

    case 'confirmed':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M15.511 22.044l-7.467-7.466 2.845-2.845 4.622 4.623L27.244 4.578l-.088-.09C24.266 1.734 20.356 0 16 0 7.156 0 0 7.156 0 16c0 8.844 7.156 16 16 16 8.844 0 16-7.156 16-16 0-3.022-.844-5.778-2.267-8.178L15.511 22.044z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M16 0c2.933 0 5.689.8 8.044 2.178l-1.466 1.466A14.01 14.01 0 0016 2C8.267 2 2 8.267 2 16s6.267 14 14 14 14-6.267 14-14c0-.889-.089-1.733-.267-2.578l1.69-1.644C31.777 13.11 32 14.533 32 16c0 8.844-7.156 16-16 16-8.844 0-16-7.156-16-16C0 7.156 7.156 0 16 0zm12.8 4.444l1.422 1.423-14.71 14.8-5.334-5.334 1.422-1.422 3.911 3.867L28.8 4.444z"
        }), void 0)]
      }, void 0);

    case 'left-chevron':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M21.121.879L6 16l15.121 15.121a3 3 0 104.243-4.243L14.484 16l10.88-10.878A2.994 2.994 0 0026.242 3 3 3 0 0021.121.88"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M24.412.293a1 1 0 00-1.415 0L7.29 16l15.707 15.708a1.002 1.002 0 001.415 0 1 1 0 000-1.415L10.118 16 24.412 1.708a1 1 0 000-1.415"
        }), void 0)]
      }, void 0);

    case 'right-chevron':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M11.121 31.121L26.242 16 11.122.879a3 3 0 10-4.243 4.243L17.759 16 6.878 26.878A2.994 2.994 0 006 29a3 3 0 005.121 2.121"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M7.583.293a1 1 0 011.415 0L24.705 16 8.998 31.708a1.002 1.002 0 01-1.415 0 1 1 0 010-1.415L21.876 16 7.583 1.708a1 1 0 010-1.415"
        }), void 0)]
      }, void 0);

    case 'close':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M16 13.159L2.841 0 0 2.841 13.159 16 0 29.159 2.841 32 16 18.841 29.16 32 32 29.159 18.841 16 32 2.841 29.16 0z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M30.104 0L16 14.104 1.895 0 0 1.895 14.104 16 0 30.105 1.895 32 16 17.896 30.104 32 32 30.105 17.896 16 32 1.895z"
        }), void 0)]
      }, void 0);

    case 'cloud':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M7 27a7 7 0 01-2.99-13.331 5 5 0 017.19-4.16 9 9 0 0116.795 4.162A7 7 0 0125 27l-18.001-.001z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M7 27a7 7 0 01-2.99-13.331 5 5 0 017.19-4.16 9 9 0 0116.795 4.162A7 7 0 0125 27l-18.001-.001zm0-2h18a5 5 0 002.138-9.522l-1.099-.52-.044-1.215a7 7 0 00-13.064-3.235l-.934 1.62-1.679-.824a3 3 0 00-4.312 2.495l-.076 1.174-1.064.503A5 5 0 007 25z"
        }), void 0)]
      }, void 0);

    case 'desc':
    case 'up-chevron':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M16 6l15.121 15.121a3 3 0 11-4.243 4.243L16 14.484 5.122 25.364A2.994 2.994 0 013 26.242 3 3 0 01.88 21.121L16 6z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M13.498,3.414 L1.42495719,15.4909131 C0.89385004,16.0229843 0.860663012,16.8619492 1.30260025,17.4095739 L1.39731593,17.515037 L1.5040659,17.6149809 C2.03857132,18.0753589 2.82324479,18.0800574 3.36223976,17.6418903 L3.47379759,17.5412235 L13.4987416,7.51235311 L23.5253797,17.5376645 C24.0929386,18.1041952 25.0096581,18.1041903 25.5749288,17.5389202 C26.1060739,17.0068111 26.1392705,16.1678438 25.6751042,15.5988103 L25.5756396,15.4887736 L13.498,3.414 Z"
        }), void 0)]
      }, void 0);

    case 'docs':
    case 'news':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M26.914 32H5.088C3.936 32 3 31.044 3 29.866V2.134C3 .956 3.936 0 5.088 0h21.826C28.066 0 29 .956 29 2.134v27.732C29 31.044 28.066 32 26.914 32zM7.001 16h18v-4h-18v4zm0 8h18v-4h-18v4zm0-16h8V4h-8v4z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M26.914 0C28.066 0 29 .954 29 2.132v27.734C29 31.044 28.066 32 26.914 32H5.086C3.934 32 3 31.044 3 29.866V2.132C3 .954 3.934 0 5.086 0h21.828zM27 29.866V2.132c0-.086-.056-.132-.086-.132H5.086C5.056 2 5 2.046 5 2.132v27.734c0 .088.056.134.086.134h21.828c.03 0 .086-.046.086-.134zM8 13.999v-2h16v2H8zm0 6v-2h16v2H8zM8 8V6h8v2H8z"
        }), void 0)]
      }, void 0);

    case 'draft':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M14.3915343,0 L14.3915343,11.1304348 L25.9047619,11.1304348 L25.9047619,32 L0,32 L0,0 L14.3915343,0 Z M25.9047619,7.61904762 L18.2857143,7.61904762 L18.2857143,0 L25.9047619,7.61904762 Z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M14.3915343,0 L14.3915343,11.1304348 L25.9047619,11.1304348 L25.9047619,32 L0,32 L0,0 L14.3915343,0 Z M12.8670476,1.52380952 L1.52380952,1.52380952 L1.52380952,30.4761905 L24.3809524,30.4761905 L24.3809524,12.6537143 L12.8677249,12.6542443 L12.8670476,1.52380952 Z M18.2857143,0 L25.9047619,7.61904762 L18.2857143,7.61904762 L18.2857143,0 Z"
        }), void 0)]
      }, void 0);

    case 'end-process':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M16 28c-2.588 0-4.985-.826-6.947-2.225L25.775 9.053A11.927 11.927 0 0128 16c0 6.617-5.383 12-12 12M4 16C4 9.383 9.383 4 16 4c2.588 0 4.985.826 6.947 2.225L6.225 22.947A11.927 11.927 0 014 16M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M16 29.333a13.271 13.271 0 01-8.433-3.014L26.319 7.567A13.271 13.271 0 0129.333 16c0 7.352-5.981 13.333-13.333 13.333M2.667 16C2.667 8.648 8.648 2.667 16 2.667c3.197 0 6.134 1.132 8.433 3.014L5.681 24.433A13.271 13.271 0 012.667 16M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0"
        }), void 0)]
      }, void 0);

    case 'expand':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M10.2426667,0.586 C11.024,1.367 11.024,2.63333333 10.2426667,3.414 L5.657,8 L10.2426667,12.586 C11.024,13.367 11.024,14.6333333 10.2426667,15.414 C9.46166667,16.1953333 8.19533333,16.1953333 7.41433333,15.414 L1.11614421e-13,8 L7.41433333,0.586 C8.19533333,-0.195333333 9.46166667,-0.195333333 10.2426667,0.586 Z M13.7576667,0.5858 C14.5386667,-0.1952 15.805,-0.1952 16.586,0.5858 L16.586,0.5858 L24.0003333,8.00013333 L16.586,15.4141333 C15.805,16.1954667 14.5386667,16.1954667 13.7576667,15.4141333 C12.9763333,14.6331333 12.9763333,13.3668 13.7576667,12.5858 L13.7576667,12.5858 L18.3433333,8.00013333 L13.7576667,3.41413333 C12.9763333,2.63313333 12.9763333,1.3668 13.7576667,0.5858 Z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M9.121,0.293 C9.51166667,0.683333333 9.51166667,1.31666667 9.121,1.707 L2.828,8 L9.121,14.293 C9.51166667,14.6833333 9.51166667,15.3166667 9.121,15.707 C8.92566667,15.9023333 8.67,16 8.414,16 C8.158,16 7.90233333,15.9023333 7.707,15.707 L-8.73375446e-14,8 L7.707,0.293 C8.09766667,-0.0976666667 8.73033333,-0.0976666667 9.121,0.293 Z M14.8788667,0.293 C15.2695333,-0.0976666667 15.9022,-0.0976666667 16.2928667,0.293 L16.2928667,0.293 L23.9998667,8 L16.2928667,15.707 C16.0975333,15.9023333 15.8418667,16 15.5858667,16 C15.3298667,16 15.0742,15.9023333 14.8788667,15.707 C14.4882,15.3166667 14.4882,14.6833333 14.8788667,14.293 L14.8788667,14.293 L21.1718667,8 L14.8788667,1.707 C14.4882,1.31666667 14.4882,0.683333333 14.8788667,0.293 Z"
        }), void 0)]
      }, void 0);

    case 'files-feature':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M38.9996518,0.123192603 C57.4784091,1.64747954 72,17.1278901 72,36 C72,55.882251 55.882251,72 36,72 C16.117749,72 0,55.882251 0,36 C0,17.1282312 14.521066,1.64803903 32.9993465,0.123275251 L32.9999969,39.439 L24.0824067,30.8404671 L23.9359874,30.7081418 C22.7389937,29.6950011 20.9445453,29.7726233 19.8404671,30.9175933 C18.6903856,32.1102704 18.7249162,34.0094514 19.9175933,35.1595329 L19.9175933,35.1595329 L35.9999969,50.6675679 L52.0824067,35.1595329 L52.2199672,35.0180206 C53.2759509,33.8586473 53.2636111,32.0625633 52.1595329,30.9175933 C51.0094514,29.7249162 49.1102704,29.6903856 47.9175933,30.8404671 L47.9175933,30.8404671 L38.9999969,39.439 Z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M36,0 C55.882251,0 72,16.117749 72,36 C72,55.882251 55.882251,72 36,72 C16.117749,72 0,55.882251 0,36 C0,16.117749 16.117749,0 36,0 Z M38.9994011,6.14806627 L38.9999969,39.439 L47.9175933,30.8404671 C49.1102704,29.6903856 51.0094514,29.7249162 52.1595329,30.9175933 C53.2636111,32.0625633 53.2759509,33.8586473 52.2199672,35.0180206 L52.0824067,35.1595329 L35.9999969,50.6675679 L19.9175933,35.1595329 C18.7249162,34.0094514 18.6903856,32.1102704 19.8404671,30.9175933 C20.9445453,29.7726233 22.7389937,29.6950011 23.9359874,30.7081418 L24.0824067,30.8404671 L32.9999969,39.439 L32.999596,6.14816585 C17.8398216,7.65352628 6,20.4440939 6,36 C6,52.5685425 19.4314575,66 36,66 C52.5685425,66 66,52.5685425 66,36 C66,20.4437509 54.1596563,7.65296217 38.9994011,6.14806627 Z"
        }), void 0)]
      }, void 0);

    case 'folder-closed':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M30 30H2a2 2 0 01-2-2V8h30a2 2 0 012 2v18a2 2 0 01-2 2zM12 6H0V4a2 2 0 012-2h8a2 2 0 012 2v2z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M30 8a2 2 0 012 2v18a2 2 0 01-2 2H2a2 2 0 01-2-2V8h30zM2 28h28V10H2v18zM2 4v2H0V4a2 2 0 012-2h8a2 2 0 012 2v2h-2V4H2z"
        }), void 0)]
      }, void 0);

    case 'folder':
    case 'folder-opened':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M32 11l-1.652 17.458C30.184 29.905 28.939 31 27.457 31H4.543c-1.482 0-2.727-1.095-2.891-2.542L0 11h32zM11.1 1c1.436 0 2.6 1.194 2.6 2.667V5h11.7C26.836 5 28 6.194 28 7.667V9H2V3.667C2 2.194 3.164 1 4.6 1h6.5z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M32 11.667L30.348 27.96c-.164 1.35-1.409 2.372-2.891 2.372H4.543c-1.482 0-2.727-1.021-2.891-2.372L0 11.667h32zm-2.95 2.666H2.95l1.345 13.26a.396.396 0 00.248.074h22.914a.396.396 0 00.248-.075l1.344-13.259zM12 1a2.667 2.667 0 012.667 2.667V5h12a2.667 2.667 0 012.666 2.667V9h-2.666V7.667H12v-4H5.333V9H2.667V3.667A2.667 2.667 0 015.333 1H12z"
        }), void 0)]
      }, void 0);

    case 'fnb':
    case 'martini':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M25.897 0a5.992 5.992 0 00-5.899 4.99H7.404L5.8.758a.992.992 0 00-.93-.642H.996v1.993h3.188L5.278 4.99H.996a.996.996 0 00-.78 1.616L12.448 22.01v8.003H8.12V32H18.75v-1.988h-4.308v-8.003L23 11.231a5.912 5.912 0 002.896.744 5.987 5.987 0 000-11.957V0zm-4.995 6.984h2.931l-3.906 4.91h-9.906l-1.86-4.91h12.74zm-14.871 0l1.86 4.91h-.935l-3.901-4.91h2.976z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M25.855.002a5.989 5.989 0 00-5.889 4.991H7.394L5.796.763a.999.999 0 00-.932-.645H.994v1.99h3.187l1.087 2.885H.995a.994.994 0 00-.777 1.618L12.431 22v8H8.108V32h10.624v-2H14.42v-8l8.551-10.767a5.9 5.9 0 002.885.746 5.98 5.98 0 005.316-2.946 5.998 5.998 0 000-6.085A5.98 5.98 0 0025.855.002zm-4.984 6.982h2.925L21.98 9.277 19.913 11.9h-9.905l-1.86-4.915h12.723zm-2.547 6.906l-4.881 6.173L8.56 13.89h9.763zM6.023 6.984l1.86 4.915H6.95l-3.9-4.915h2.973zm19.832 3.018c-.56 0-1.113-.118-1.624-.347l2.405-3.031a1.001 1.001 0 00-.781-1.618H21.99a3.994 3.994 0 017.848 1.333 3.996 3.996 0 01-3.983 3.663z"
        }), void 0)]
      }, void 0);

    case 'free-form':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M18.43 0l9.094 9.333h.143V32H5V0h13.43zm-2.763 2.667h-8v26.666H25V12h-9.333V2.667zM14.086 16l2.247 2.343L18.581 16h3.663l-4.079 4.184 4.168 4.276H18.67l-2.337-2.436-2.336 2.436h-3.664l4.169-4.276L10.422 16h3.664zm4.247-12.279l.002 5.612H23.8l-5.467-5.612z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M18.43 0l9.094 9.333h.143V32H5V0h13.43zm-2.763 2.667h-8v26.666H25V12h-9.333V2.667zM14.086 16l2.247 2.343L18.581 16h3.663l-4.079 4.184 4.168 4.276H18.67l-2.337-2.436-2.336 2.436h-3.664l4.169-4.276L10.422 16h3.664zm4.247-12.279l.002 5.612H23.8l-5.467-5.612z"
        }), void 0)]
      }, void 0);

    case 'from-template':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M30.333 6.667V32H7.667v-6.667h2.666v4h17.334v-20H25V6.667h5.333zM23.667 0v24H1V0h22.667zM21 2.667H3.667v18.666H21V2.667zM18.333 16v2.667H13V16h5.333zm-6.666 0v2.667H6.333V16h5.334zM10.086 4.782l2.247 2.342 2.248-2.342h3.663l-4.079 4.183 4.168 4.276H14.67l-2.337-2.435-2.336 2.435H6.333l4.169-4.276-4.08-4.183h3.664z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M30.333 6.667V32H7.667v-6.667h2.666v4h17.334v-20H25V6.667h5.333zM23.667 0v24H1V0h22.667zM21 2.667H3.667v18.666H21V2.667zM18.333 16v2.667H13V16h5.333zm-6.666 0v2.667H6.333V16h5.334zM10.086 4.782l2.247 2.342 2.248-2.342h3.663l-4.079 4.183 4.168 4.276H14.67l-2.337-2.435-2.336 2.435H6.333l4.169-4.276-4.08-4.183h3.664z"
        }), void 0)]
      }, void 0);

    case 'fundamentals':
    case 'pie-chart':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M31.998 17.333c-.427 5.041-3.233 9.8-7.955 12.522-4.722 2.722-10.253 2.77-14.841.617l7.598-13.14h15.198zM6.888 2.862l7.599 13.137-7.6 13.142A15.946 15.946 0 012.149 24C-2.05 16.737.104 7.555 6.888 2.862zM9.2 1.528c7.464-3.52 16.507-.793 20.707 6.47A15.907 15.907 0 0132 14.667H16.8L9.2 1.528z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M16 29.333c-1.952 0-3.804-.425-5.476-1.181l6.246-10.819h12.497c-.672 6.729-6.365 12-13.267 12M2.667 16c0-4.448 2.191-8.392 5.549-10.815L14.46 16 8.216 26.815C4.858 24.392 2.666 20.448 2.666 16m26.6-1.333H16.77L10.524 3.848A13.248 13.248 0 0116 2.667c6.902 0 12.595 5.271 13.267 12M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0"
        }), void 0)]
      }, void 0);

    case 'grid-view':
    case 'grid':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M24 10v8H13v-8h11zm-13 0v8H0v-8h11zM24 0v8H13V0h11zM11 0v8H0V0h11z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M24 10v8H13v-8h11zm-13 0v8H0v-8h11zm12 1h-9v6h9v-6zm-13 0H1v6h9v-6zM24 0v8H13V0h11zM11 0v8H0V0h11zm12 1h-9v6h9V1zM10 1H1v6h9V1z"
        }), void 0)]
      }, void 0);

    case 'header-logo':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M30.37 14.64h1.177v-2.31H30.37v2.31zm-3.086 0h2.634v-2.31h-2.634v2.31zm-7.098-9.348h5.348v-.84h-5.348v.84zm5.8 1.923h.846v-1.47h-.845v1.47zm0 4.662h.846v-4.21h-.845v4.21zm0 2.763h.846v-2.31h-.845v2.31zm-2.324 0h1.872v-2.31h-1.872v2.31zm-3.476 0h3.024v-2.31h-3.024v2.31zm0-6.973l.001 2.599h3.475v1.611h1.872v-4.21h-5.348zm0-.452h5.348v-1.47h-5.348v1.47zm0 4.662h3.024v-1.159h-3.024v1.159zm7.098 0h2.634v-4.21h-2.634v4.21zm4.716 0v3.216H19.734V4h6.253v1.292h1.297v1.923h3.086v4.662H32zm-18.043 4.66h5.777v-1.444h-5.777v1.444zm-11.05 9.321c.386.045.76.058.985.058 1.987 0 3.248-1.272 3.248-3.162 0-1.636-.945-2.817-2.225-2.817-.555 0-.926.114-2.008.757v-.787h-.599L0 20.608v.566h.956v6.592l-.86.214v.545h3.773v-.545l-.962-.214v-1.908zm0-4.623c.341-.042.51-.061.671-.061.968 0 1.492.642 1.492 1.851 0 1.428-.64 2.173-1.836 2.173-.1 0-.169 0-.327-.007v-3.956zm13.168 1.79c.895-1.128 1.211-1.583 1.211-2.137 0-.551-.438-.995-1.023-.995-.36 0-.684.17-.843.346v2.299l-1.466 1.954v-4.455H12.56l-2.318 3.842v-3.842h-.8l-2.105.513v.538l1.148.116v4.712h1.483l2.223-3.653v3.653h1.624l2.26-2.89zm4.926-2.492c-.998.161-1.508.899-1.508 2.196 0 1.306.68 2.179 1.722 2.179.484 0 .925-.161 1.851-.616v1.056c-1.111.51-1.766.668-2.661.668-.97 0-1.652-.257-2.21-.825-.57-.571-.856-1.326-.856-2.166 0-1.868 1.383-3.132 3.404-3.132 1.342 0 2.265.613 2.265 1.513 0 .58-.43.979-1.067.979-.327 0-.596-.086-.94-.285v-1.567z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M30.37 14.64h1.177v-2.31H30.37v2.31zm-3.086 0h2.634v-2.31h-2.634v2.31zm-7.098-9.348h5.348v-.84h-5.348v.84zm5.8 1.923h.846v-1.47h-.845v1.47zm0 4.662h.846v-4.21h-.845v4.21zm0 2.763h.846v-2.31h-.845v2.31zm-2.324 0h1.872v-2.31h-1.872v2.31zm-3.476 0h3.024v-2.31h-3.024v2.31zm0-6.973l.001 2.599h3.475v1.611h1.872v-4.21h-5.348zm0-.452h5.348v-1.47h-5.348v1.47zm0 4.662h3.024v-1.159h-3.024v1.159zm7.098 0h2.634v-4.21h-2.634v4.21zm4.716 0v3.216H19.734V4h6.253v1.292h1.297v1.923h3.086v4.662H32zm-18.043 4.66h5.777v-1.444h-5.777v1.444zm-11.05 9.321c.386.045.76.058.985.058 1.987 0 3.248-1.272 3.248-3.162 0-1.636-.945-2.817-2.225-2.817-.555 0-.926.114-2.008.757v-.787h-.599L0 20.608v.566h.956v6.592l-.86.214v.545h3.773v-.545l-.962-.214v-1.908zm0-4.623c.341-.042.51-.061.671-.061.968 0 1.492.642 1.492 1.851 0 1.428-.64 2.173-1.836 2.173-.1 0-.169 0-.327-.007v-3.956zm13.168 1.79c.895-1.128 1.211-1.583 1.211-2.137 0-.551-.438-.995-1.023-.995-.36 0-.684.17-.843.346v2.299l-1.466 1.954v-4.455H12.56l-2.318 3.842v-3.842h-.8l-2.105.513v.538l1.148.116v4.712h1.483l2.223-3.653v3.653h1.624l2.26-2.89zm4.926-2.492c-.998.161-1.508.899-1.508 2.196 0 1.306.68 2.179 1.722 2.179.484 0 .925-.161 1.851-.616v1.056c-1.111.51-1.766.668-2.661.668-.97 0-1.652-.257-2.21-.825-.57-.571-.856-1.326-.856-2.166 0-1.868 1.383-3.132 3.404-3.132 1.342 0 2.265.613 2.265 1.513 0 .58-.43.979-1.067.979-.327 0-.596-.086-.94-.285v-1.567z"
        }), void 0)]
      }, void 0);

    case 'help-question':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M16 0c8.836 0 16 7.164 16 16s-7.164 16-16 16C7.163 32 0 24.836 0 16S7.163 0 16 0zm1.822 21.106h-3.374v3.261h3.374v-3.261zM15.848 7.564c-1.295 0-2.385.286-3.273.858-1.407.895-2.155 2.415-2.246 4.559h3.262c0-.625.181-1.226.545-1.806.364-.579.982-.869 1.852-.869.886 0 1.496.235 1.83.706.334.47.5.991.5 1.563 0 .496-.15.951-.45 1.365-.164.24-.382.463-.652.666l-.821.643c-.81.632-1.313 1.19-1.508 1.676-.195.485-.315 1.363-.36 2.635h3.058c.008-.602.057-1.046.147-1.332.142-.451.431-.846.866-1.185l.8-.62c.81-.632 1.357-1.151 1.642-1.558.488-.67.732-1.493.732-2.471 0-1.595-.563-2.798-1.687-3.611-1.125-.813-2.537-1.219-4.237-1.219z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M16 0c8.836 0 16 7.164 16 16s-7.164 16-16 16S0 24.836 0 16 7.164 0 16 0zm0 2.667C8.648 2.667 2.667 8.648 2.667 16S8.648 29.333 16 29.333 29.333 23.352 29.333 16 23.352 2.667 16 2.667zm1.823 18.439v3.261h-3.375v-3.261h3.375zM15.848 7.564c1.7 0 3.112.407 4.237 1.22 1.125.812 1.687 2.015 1.687 3.61 0 .978-.244 1.802-.732 2.471-.284.407-.832.926-1.643 1.558l-.798.62c-.436.339-.725.734-.867 1.185-.09.286-.14.73-.147 1.332h-3.057c.044-1.272.164-2.15.36-2.635.195-.485.697-1.044 1.507-1.676l.821-.643c.27-.203.488-.425.653-.666.3-.413.45-.869.45-1.365a2.64 2.64 0 00-.5-1.563c-.335-.47-.945-.706-1.83-.706-.87 0-1.489.29-1.852.87-.365.579-.546 1.18-.546 1.805h-3.262c.09-2.144.839-3.664 2.246-4.56.888-.57 1.979-.857 3.273-.857z"
        }), void 0)]
      }, void 0);

    case 'home':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M27 18v12H5V18H0L16 2l16 16h-5z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M16 2l16 16h-5v12H5V18H0L16 2zm0 3L5 16h2v12h18V16h2L16 5z"
        }), void 0)]
      }, void 0);

    case 'hyperlink':
    case 'link':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M7.405 8.82l1.415 1.414-6.544 6.544 4.95 4.95 6.544-6.544 1.414 1.414-7.015 7.015a1.33 1.33 0 01-1.886 0L.39 17.72a1.333 1.333 0 010-1.885L7.405 8.82zm9.372-4.187l2.593 2.593L7.226 19.37l-2.593-2.593L16.777 4.633zm0-4.633c.342 0 .683.13.943.39l5.893 5.893c.52.52.52 1.365 0 1.886l-7.015 7.015-1.414-1.415 6.543-6.543-4.95-4.95-6.543 6.544L8.82 7.405 15.835.39c.26-.26.601-.39.943-.39z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M15.3 14.2l7.146-7.146-5.5-5.5L9.8 8.7 8.7 7.604 15.846.458a1.55 1.55 0 012.2 0l5.496 5.496a1.55 1.55 0 010 2.2L16.396 15.3 15.3 14.2zm-1.1 1.1l1.1 1.096-7.146 7.146a1.55 1.55 0 01-2.2 0L.458 18.046a1.55 1.55 0 010-2.2L7.604 8.7 8.7 9.8l-7.146 7.146 5.5 5.5L14.2 15.3zm-8.246 1.646L16.953 5.947l1.1 1.1-11 10.999-1.099-1.1z"
        }), void 0)]
      }, void 0);

    case 'hyperlink-remove':
    case 'link-remove':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M24.05 10.887l-2.96 3.024-2.933-2.935 2.965-3.023 2.929 2.934zM10.864 27L5 21.113l3.822-3.819L5.89 14.36.604 19.668a2.063 2.063 0 000 2.917L9.4 31.397a2.058 2.058 0 002.912 0l5.29-5.287-2.939-2.934-3.8 3.824zM31.38 9.402L22.584.604a2.062 2.062 0 00-2.916 0L14.37 5.89l2.933 2.934 3.819-3.823 5.863 5.886-3.823 3.82 2.934 2.934 5.285-5.291a2.063 2.063 0 000-2.948zM7.933 21.113l2.93 2.934 3.253-3.156-2.933-2.93-3.25 3.152zm19.62 9.301l2.912-2.952L4.462 1.586 1.55 4.538l26.004 25.876z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M21.777 17.635l8.15-8.23-7.332-7.332-8.244 8.15-1.462-1.484L21.13.61a2.066 2.066 0 012.932 0l7.328 7.328a2.066 2.066 0 010 2.933l-8.145 8.239-1.467-1.476zM9.405 29.927l-7.332-7.332 8.15-8.057-1.467-1.467-8.145 8.057a2.066 2.066 0 000 2.933l7.328 7.328a2.066 2.066 0 002.933 0l8.083-8.123-1.466-1.462-8.084 8.123zm9.11-14.931l5.546-5.59-1.466-1.467-5.546 5.59 1.466 1.467zm-9.11 9.065l5.51-5.546-1.466-1.466-5.51 5.546 1.466 1.466zm21.424 5.404L2.51 1.171 1.09 2.584l28.325 28.294 1.413-1.413z"
        }), void 0)]
      }, void 0);

    case 'center-map':
    case 'hypothesis':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M4.031 17.338c.62 5.574 5.057 10.01 10.63 10.63V32C6.862 31.356.645 25.139 0 17.338h4.031zm27.969 0c-.644 7.8-6.861 14.018-14.662 14.662v-4.033c5.574-.62 10.011-5.055 10.63-10.629H32zm-17.338 0v7.475a8.933 8.933 0 01-7.473-7.475h7.473zm10.149 0a8.933 8.933 0 01-7.473 7.475v-7.475h7.473zm-7.473-10.15a8.933 8.933 0 017.473 7.474h-7.473V7.187zm0-7.188C25.138.644 31.356 6.861 32 14.662h-4.031c-.62-5.574-5.057-10.01-10.63-10.63V0zm-2.676 0v4.033c-5.574.62-10.011 5.055-10.63 10.629H0C.644 6.862 6.861.644 14.662 0zm0 7.187v7.475H7.189a8.933 8.933 0 017.473-7.475z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M17.333 29.267V23.88a7.994 7.994 0 006.547-6.547h5.387c-.628 6.29-5.644 11.306-11.934 11.934zm-14.6-11.934H8.12a7.994 7.994 0 006.547 6.547v5.387c-6.29-.628-11.306-5.644-11.934-11.934zm11.934-14.6V8.12a7.994 7.994 0 00-6.547 6.547H2.733C3.361 8.377 8.377 3.36 14.667 2.734zm2.666 11.934v-3.825a5.343 5.343 0 013.825 3.825h-3.825zm0 2.666h3.825a5.344 5.344 0 01-3.825 3.825v-3.825zm-2.666 0v3.825a5.344 5.344 0 01-3.825-3.825h3.825zm0-2.666h-3.825a5.343 5.343 0 013.825-3.825v3.825zm14.6 0H23.88a7.994 7.994 0 00-6.547-6.547V2.734c6.29.627 11.306 5.643 11.934 11.933zM16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0z"
        }), void 0)]
      }, void 0);

    case 'information':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "m16 0c8.836 0 16 7.164 16 16s-7.164 16-16 16-16-7.164-16-16 7.164-16 16-16z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill variant",
          d: "m18 15v10h-4v-10h4zm-2-8c1.104 0 2 0.89467 2 2 0 1.104-0.896 2-2 2s-2-0.896-2-2c0-1.1053 0.896-2 2-2z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M16 32C7.164 32 0 24.836 0 16S7.164 0 16 0c8.837 0 16 7.164 16 16s-7.163 16-16 16zm0-30C8.28 2 2 8.28 2 16s6.28 14 14 14 14-6.28 14-14S23.72 2 16 2zm-1 22V14h2v10h-2zm1-14a1 1 0 110-2 1 1 0 010 2z"
        }), void 0)]
      }, void 0);

    case 'ingestion-upload':
    case 'ingestionupload':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M10.419 11.217c-.783.78-2.05.78-2.832 0a1.993 1.993 0 010-2.825L16 0l8.412 8.392c.783.78.783 2.045 0 2.825-.391.39-.902.585-1.415.585a1.999 1.999 0 01-1.417-.585l-3.578-3.57V24h-4.005V7.647l-3.58 3.57zM7 31.999V28h18v3.999h-.93V32H7.93v-.001H7z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M9.714 9.134a1.003 1.003 0 11-1.418-1.419L16.013 0l7.715 7.715a1.003 1.003 0 01-1.417 1.419l-5.296-5.296v18.335H15.01V3.838L9.714 9.134zM7 32v-2h18v2H7z"
        }), void 0)]
      }, void 0);

    case 'insight':
    case 'light-bulb':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M18.778 29.333a1.333 1.333 0 110 2.667h-5.334a1.333 1.333 0 110-2.667h5.334zm1.333-4a1.333 1.333 0 110 2.667h-8a1.333 1.333 0 110-2.667h8zm3.44-4.507a1.333 1.333 0 011.87-.23l2.452 1.915a1.333 1.333 0 01-1.642 2.102l-2.451-1.916a1.333 1.333 0 01-.23-1.871zm-16.706-.23a1.333 1.333 0 111.642 2.101l-2.45 1.916a1.334 1.334 0 01-1.643-2.102l2.451-1.915zm9.266-13.88c4.41 0 8 3.59 8 8 0 2.14-.828 4.14-2.335 5.65-.07.19-.252.8-.51 2.5-.1.66-.668 1.134-1.316 1.134h-7.678a1.333 1.333 0 01-1.316-1.134c-.258-1.7-.44-2.31-.51-2.5a7.93 7.93 0 01-2.335-5.65c0-4.41 3.59-8 8-8zm13.778 6.617a1.333 1.333 0 110 2.667h-3.111a1.333 1.333 0 110-2.667h3.11zm-24.445 0a1.333 1.333 0 110 2.667h-3.11a1.333 1.333 0 110-2.667h3.11zm19.65-9.536a1.334 1.334 0 011.886 1.886l-2.2 2.2a1.333 1.333 0 11-1.885-1.886l2.2-2.2zm-19.852 0c.52-.52 1.365-.52 1.886 0l2.2 2.2a1.333 1.333 0 11-1.886 1.886l-2.2-2.2a1.334 1.334 0 010-1.886zM15.889 0c.736 0 1.333.597 1.333 1.333V4a1.333 1.333 0 11-2.666 0V1.333c0-.736.596-1.333 1.333-1.333z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M18.778 29.333a1.333 1.333 0 110 2.667h-5.334a1.333 1.333 0 110-2.667h5.334zm1.333-4a1.333 1.333 0 110 2.667h-8a1.333 1.333 0 110-2.667h8zm3.44-4.507a1.333 1.333 0 011.87-.23l2.452 1.915a1.333 1.333 0 01-1.642 2.102l-2.451-1.916a1.333 1.333 0 01-.23-1.871zm-16.706-.23a1.333 1.333 0 111.642 2.101l-2.45 1.916a1.334 1.334 0 01-1.643-2.102l2.451-1.915zm9.266-13.88c4.411 0 8 3.589 8 8 0 2.14-.828 4.139-2.335 5.65-.07.19-.252.8-.51 2.5a1.334 1.334 0 01-2.636-.4c.416-2.745.722-3.469 1.176-3.903a5.292 5.292 0 001.638-3.847 5.34 5.34 0 00-5.333-5.333 5.34 5.34 0 00-5.333 5.333c0 1.465.582 2.832 1.64 3.848.452.433.758 1.157 1.174 3.903a1.333 1.333 0 01-2.636.4c-.258-1.701-.44-2.312-.51-2.502a7.93 7.93 0 01-2.335-5.649c0-4.411 3.589-8 8-8zm13.778 6.617a1.333 1.333 0 110 2.667h-3.111a1.333 1.333 0 110-2.667h3.11zm-24.445 0a1.333 1.333 0 110 2.667h-3.11a1.333 1.333 0 110-2.667h3.11zm19.65-9.536a1.334 1.334 0 011.886 1.886l-2.2 2.2a1.333 1.333 0 11-1.885-1.886l2.2-2.2zm-19.852 0c.52-.52 1.365-.52 1.886 0l2.2 2.2a1.333 1.333 0 11-1.886 1.886l-2.2-2.2a1.334 1.334 0 010-1.886zM15.889 0c.736 0 1.333.597 1.333 1.333V4a1.333 1.333 0 11-2.666 0V1.333c0-.736.596-1.333 1.333-1.333z"
        }), void 0)]
      }, void 0);

    case 'layout-double':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M3.86666667,32 C1.74720893,32 0,30.1755664 0,28.1333333 L0,28.1333333 L0,3.86666667 C0,1.82443363 1.74720893,0 3.86666667,0 L3.86666667,0 L28.1333333,0 C30.252791,0 32,1.82443363 32,3.86666667 L32,3.86666667 L32,28.1333333 C32,30.1755664 30.252791,32 28.1333333,32 L28.1333333,32 L3.86666667,32 Z M14.9333333,2.13333333 L3.86666667,2.13333333 C2.90986667,2.13333333 2.13333333,3.0208 2.13333333,3.86666667 L2.13333333,3.86666667 L2.13333333,28.1333333 C2.13333333,28.9792 2.90986667,29.8666667 3.86666667,29.8666667 L3.86666667,29.8666667 L14.9333333,29.8666667 L14.9333333,2.13333333 Z M28.1333333,2.13333333 L17.0666667,2.13333333 L17.0666667,29.8666667 L28.1333333,29.8666667 C29.0397755,29.8666667 29.784427,29.0701591 29.8603004,28.2671014 L29.8666667,28.1333333 L29.8666667,3.86666667 C29.8666667,3.0208 29.0901333,2.13333333 28.1333333,2.13333333 L28.1333333,2.13333333 Z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M3.86666667,32 C1.74720893,32 0,30.1755664 0,28.1333333 L0,28.1333333 L0,3.86666667 C0,1.82443363 1.74720893,0 3.86666667,0 L3.86666667,0 L28.1333333,0 C30.252791,0 32,1.82443363 32,3.86666667 L32,3.86666667 L32,28.1333333 C32,30.1755664 30.252791,32 28.1333333,32 L28.1333333,32 L3.86666667,32 Z M14.9333333,2.13333333 L3.86666667,2.13333333 C2.90986667,2.13333333 2.13333333,3.0208 2.13333333,3.86666667 L2.13333333,3.86666667 L2.13333333,28.1333333 C2.13333333,28.9792 2.90986667,29.8666667 3.86666667,29.8666667 L3.86666667,29.8666667 L14.9333333,29.8666667 L14.9333333,2.13333333 Z M28.1333333,2.13333333 L17.0666667,2.13333333 L17.0666667,29.8666667 L28.1333333,29.8666667 C29.0397755,29.8666667 29.784427,29.0701591 29.8603004,28.2671014 L29.8666667,28.1333333 L29.8666667,3.86666667 C29.8666667,3.0208 29.0901333,2.13333333 28.1333333,2.13333333 L28.1333333,2.13333333 Z"
        }), void 0)]
      }, void 0);

    case 'layout-single':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M28.1333333,0 L3.86666667,0 C1.74720893,0 0,1.82443363 0,3.86666667 L0,28.1333333 C0,30.1755664 1.74720893,32 3.86666667,32 L28.1333333,32 C30.252791,32 32,30.1755664 32,28.1333333 L32,3.86666667 C32,1.82443363 30.252791,0 28.1333333,0 Z M28.1333333,2.13333333 C29.0901333,2.13333333 29.8666667,3.0208 29.8666667,3.86666667 L29.8666667,28.1333333 C29.8666667,28.9792 29.0901333,29.8666667 28.1333333,29.8666667 L3.86666667,29.8666667 C2.90986667,29.8666667 2.13333333,28.9792 2.13333333,28.1333333 L2.13333333,3.86666667 C2.13333333,3.0208 2.90986667,2.13333333 3.86666667,2.13333333 L28.1333333,2.13333333 Z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M28.1333333,0 L3.86666667,0 C1.74720893,0 0,1.82443363 0,3.86666667 L0,28.1333333 C0,30.1755664 1.74720893,32 3.86666667,32 L28.1333333,32 C30.252791,32 32,30.1755664 32,28.1333333 L32,3.86666667 C32,1.82443363 30.252791,0 28.1333333,0 Z M28.1333333,2.13333333 C29.0901333,2.13333333 29.8666667,3.0208 29.8666667,3.86666667 L29.8666667,28.1333333 C29.8666667,28.9792 29.0901333,29.8666667 28.1333333,29.8666667 L3.86666667,29.8666667 C2.90986667,29.8666667 2.13333333,28.9792 2.13333333,28.1333333 L2.13333333,3.86666667 C2.13333333,3.0208 2.90986667,2.13333333 3.86666667,2.13333333 L28.1333333,2.13333333 Z"
        }), void 0)]
      }, void 0);

    case 'list-view':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M24 14v4H6v-4h18zM4 14v4H0v-4h4zm20-7v4H6V7h18zM4 7v4H0V7h4zm20-7v4H6V0h18zM4 0v4H0V0h4z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M24 14v4H6v-4h18zM4 14v4H0v-4h4zm19 1H7v2h16v-2zM3 15H1v2h2v-2zm21-8v4H6V7h18zM4 7v4H0V7h4zm19 1H7v2h16V8zM3 8H1v2h2V8zm21-8v4H6V0h18zM4 0v4H0V0h4zm19 1H7v2h16V1zM3 1H1v2h2V1z"
        }), void 0)]
      }, void 0);

    case 'locked':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M16.333 0a8 8 0 018 8v2.667H27a2.667 2.667 0 012.667 2.666v16A2.667 2.667 0 0127 32H5.667A2.667 2.667 0 013 29.333v-16a2.667 2.667 0 012.667-2.666h2.666V8a8 8 0 018-8zm1.334 17.333H15v8h2.667v-8zM16.333 2.667A5.34 5.34 0 0011 8v2.667h10.667V8a5.34 5.34 0 00-5.334-5.333z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M16.333 0a8 8 0 018 8v2.667H27a2.667 2.667 0 012.667 2.666v16A2.667 2.667 0 0127 32H5.667A2.667 2.667 0 013 29.333v-16a2.667 2.667 0 012.667-2.666h2.666V8a8 8 0 018-8zM27 13.333H5.667v16H27v-16zm-9.333 4v8H15v-8h2.667zM16.333 2.667A5.34 5.34 0 0011 8v2.667h10.667V8a5.34 5.34 0 00-5.334-5.333z"
        }), void 0)]
      }, void 0);

    case 'logout':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M25.038 9.044L32 16.006l-6.95 6.95c-.78.78-2.046.78-2.828 0a2.001 2.001 0 010-2.828l2.122-2.122H13.146v-4h11.198l-2.134-2.134a1.998 1.998 0 010-2.828 1.998 1.998 0 012.828 0zM16 22h.47L20 25.53V30a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2h16a2 2 0 012 2v4.47L16.47 10H16V4H4v24h12v-6z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M22.414 9.24l1.414-1.413L32 15.999l-8.172 8.174-1.414-1.414 5.758-5.76H14.454v-2h13.718L22.414 9.24zM18 30v-5h2v5a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2h16a2 2 0 012 2v5h-2V2H2v28h16z"
        }), void 0)]
      }, void 0);

    case 'management':
    case 'briefcase':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M32 18.333v9.334a2.667 2.667 0 01-2.667 2.666H2.667A2.667 2.667 0 010 27.667v-9.334h32zM29.333 9A2.667 2.667 0 0132 11.667v4H0V9h29.333zm-8-8A2.667 2.667 0 0124 3.667v2.666h-2.667V3.667H10.667v2.666H8V3.667A2.667 2.667 0 0110.667 1h10.666z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M29.333 9A2.667 2.667 0 0132 11.667v16a2.667 2.667 0 01-2.667 2.666H2.667A2.667 2.667 0 010 27.667V9h29.333zm0 9.333H2.667v9.334h26.666v-9.334zm0-6.666H2.667v4h26.666v-4zM21.333 1A2.667 2.667 0 0124 3.667v2.666h-2.667V3.667H10.667v2.666H8V3.667A2.667 2.667 0 0110.667 1h10.666z"
        }), void 0)]
      }, void 0);

    case 'minus':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M16,14 L32,14 L32,18 L16,18 L0,18 L0,14 L16,14 Z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M24,15 L32,15 L32,17 L24,17 L16,17 L8,17 L0,17 L0,15 L8,15 L16,15 L24,15 Z"
        }), void 0)]
      }, void 0);

    case 'more-vert':
    case 'vertical-more':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M16 8a4 4 0 110-8 4 4 0 010 8zm0 4a4 4 0 110 8 4 4 0 010-8zm0 12a4 4 0 110 8 4 4 0 010-8z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M18 28a2 2 0 10-4 0 2 2 0 004 0zm0-24a2 2 0 10-4 0 2 2 0 004 0zm0 12a2 2 0 10-4 0 2 2 0 004 0z"
        }), void 0)]
      }, void 0);

    case 'note-error':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M16.72 7.21l-3.812 3.813 3.812 3.812-1.885 1.885-3.812-3.812L7.21 16.72l-1.878-1.876 3.812-3.812-3.812-3.813L7.22 5.333l3.812 3.813 3.812-3.813 1.877 1.878zm3.64 21.993v-8.739l8.843-.105-8.844 8.844zM29.332 0H0v29.333A2.667 2.667 0 002.667 32h17.562c.707 0 1.385-.28 1.886-.78l9.104-9.105c.5-.5.781-1.179.781-1.886V2.667A2.667 2.667 0 0029.333 0z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M29.333 0A2.667 2.667 0 0132 2.667v17.562c0 .707-.28 1.385-.781 1.886l-9.104 9.104c-.5.5-1.179.781-1.886.781H2.667A2.667 2.667 0 010 29.333V0h29.333zm0 2.667H2.667v26.666h16V18.667h10.666v-16zM28.23 21.333h-6.896v6.896l6.896-6.896zm-13.386-16l1.877 1.878-3.812 3.812 3.812 3.812-1.885 1.885-3.813-3.812L7.21 16.72l-1.877-1.877 3.813-3.812L5.333 7.22 7.22 5.333l3.812 3.812 3.812-3.812z"
        }), void 0)]
      }, void 0);

    case 'notification':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M20.07 29.333A4.45 4.45 0 0116 32a4.45 4.45 0 01-4.07-2.667h8.14zm1.162-22.666c1.686 0 3.2 1.066 3.767 2.655l3.16 9.18 3.809 1.284V24H32v2.667H0v-6.884L3.842 18.5l3.154-9.164a4.014 4.014 0 013.772-2.67h10.464zM16 0c2.99 0 5.333 1.757 5.333 4h-2.666c0-.544-1.04-1.333-2.667-1.333-1.628 0-2.667.789-2.667 1.333h-2.666c0-2.243 2.342-4 5.333-4z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M20.07 29.333A4.45 4.45 0 0116 32a4.45 4.45 0 01-4.07-2.667h8.14zm1.162-22.666c1.686 0 3.2 1.066 3.767 2.655l3.16 9.18 3.81 1.284L31.967 24H32v2.667H0v-6.884L3.842 18.5l3.154-9.164a4.014 4.014 0 013.772-2.67h10.464zm0 2.666H10.768c-.562 0-1.067.356-1.255.885L5.936 20.612l-3.27 1.092V24h26.635v-2.3l-3.237-1.09-3.582-10.406a1.331 1.331 0 00-1.25-.87zM16 0c2.99 0 5.333 1.757 5.333 4h-2.666c0-.544-1.039-1.333-2.667-1.333S13.333 3.456 13.333 4h-2.666c0-2.243 2.342-4 5.333-4z"
        }), void 0)]
      }, void 0);

    case 'partnership':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M7.333 16.222c4.05 0 7.334 2.222 7.334 3.111V30H0V19.333c0-.889 3.284-3.11 7.333-3.11zm17.334 0c4.05 0 7.333 2.222 7.333 3.111V30H17.333V19.333c0-.889 3.284-3.11 7.334-3.11zM7.333 2a6 6 0 110 12 6 6 0 010-12zm17.334 0a6 6 0 110 12 6 6 0 010-12z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M23.333 15.667c3.82 0 8.667 1.95 8.667 4.143v10.968H0V19.81c0-2.192 4.846-4.143 8.667-4.143 2.58 0 5.626.89 7.333 2.143 1.707-1.253 4.753-2.143 7.333-2.143zm0 2.666c-3.044 0-5.398 1.249-6 1.8v7.978h12v-7.979c-.607-.554-2.961-1.799-6-1.799zm-14.666 0c-3.039 0-5.393 1.245-6 1.799v7.98h12v-7.978c-.602-.552-2.956-1.8-6-1.8zM8.667 1a6 6 0 110 12 6 6 0 010-12zm14.666 0a6 6 0 110 12 6 6 0 010-12zM8.667 3.667A3.337 3.337 0 005.333 7a3.337 3.337 0 003.334 3.333A3.337 3.337 0 0012 7a3.337 3.337 0 00-3.333-3.333zm14.666 0A3.337 3.337 0 0020 7a3.337 3.337 0 003.333 3.333A3.337 3.337 0 0026.667 7a3.337 3.337 0 00-3.334-3.333z"
        }), void 0)]
      }, void 0);

    case 'pdf':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M0 4h30a2 2 0 012 2v22H0V4zm6.243 13.573h1.446c1.146 0 2.055-.301 2.727-.903.673-.602 1.009-1.396 1.009-2.38 0-.985-.336-1.779-1.009-2.383C9.744 11.302 8.835 11 7.69 11H4v10h2.243v-3.427zm0-1.786v-3.001h1.446c.491 0 .864.142 1.118.426.255.283.382.647.382 1.092 0 .435-.128.79-.385 1.068-.257.277-.628.415-1.115.415H6.243zM12.666 21h3.536c1.137 0 2.088-.382 2.854-1.147.765-.765 1.147-1.75 1.147-2.953v-1.8c0-1.2-.382-2.183-1.147-2.95-.766-.767-1.717-1.15-2.854-1.15h-3.536v10zm2.242-8.214h1.294c.51 0 .928.215 1.258.645.33.43.494.982.494 1.656V16.9c0 .682-.165 1.238-.494 1.669-.33.43-.749.645-1.258.645h-1.294v-6.428zm12.415 4.19V15.19h-3.536v-2.404H28V11h-6.456v10h2.243v-4.025h3.536z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M30 4a2 2 0 012 2v22H0V4h30zM2 26h28V6H2v20zm5.869-8.742V20H6v-8h3.074c.955 0 1.713.242 2.273.725.56.484.84 1.12.84 1.907 0 .787-.28 1.422-.84 1.904-.56.481-1.318.722-2.273.722H7.87zm0-1.428h1.205c.406 0 .716-.111.93-.333.213-.221.32-.506.32-.854 0-.355-.106-.647-.318-.874-.212-.227-.522-.34-.932-.34H7.87v2.4zM13.221 20v-8h2.948c.947 0 1.74.307 2.377.92.638.614.957 1.4.957 2.36v1.44c0 .963-.319 1.75-.957 2.362-.637.612-1.43.918-2.377.918H13.22zm1.87-6.571v5.142h1.078c.424 0 .773-.172 1.047-.516.275-.344.412-.79.412-1.335v-1.45c0-.54-.137-.98-.412-1.325-.274-.344-.623-.516-1.047-.516H15.09zm10.345 3.351h-2.947V20h-1.87v-8H26v1.429h-3.511v1.923h2.947v1.428z"
        }), void 0)]
      }, void 0);

    case 'pencil':
    case 'edit':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M19.595 5.259l7.147 7.146L7.147 32H0v-7.147L19.595 5.259zM25.957 0c.683 0 1.365.26 1.886.781l3.376 3.376a2.666 2.666 0 010 3.771l-2.591 2.592-7.148-7.148 2.592-2.59A2.658 2.658 0 0125.957 0z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M26.742 8.634l-3.377-3.377 2.59-2.59h.002l3.376 3.376-2.591 2.591zm-20.7 20.7H2.668v-3.376L21.48 7.143l3.376 3.377L6.043 29.333zM31.22 4.156L27.844.78A2.66 2.66 0 0025.957 0c-.682 0-1.364.26-1.885.781L0 24.853V32h7.147L31.22 7.928a2.666 2.666 0 000-3.771z"
        }), void 0)]
      }, void 0);

    case 'people':
    case 'leader':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M15.933 17.867A8.947 8.947 0 017 8.933a8.933 8.933 0 118.933 8.934zm13.46 3.484a.995.995 0 01.607.916V31c0 .552-.45 1-1.005 1H3.005A1.002 1.002 0 012 31v-8.733c0-.398.236-.758.603-.916a32.851 32.851 0 0111.162-2.52l2.233 2.005-2.295 8.186 2.197 2.222 2.393-2.222-2.295-8.186 2.232-2.005c3.84.18 7.62 1.034 11.163 2.52z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M16.027 17.622a8.824 8.824 0 01-8.81-8.811 8.811 8.811 0 118.81 8.81zm0-15.65a6.838 6.838 0 100 13.677 6.838 6.838 0 000-13.676zm13.151 19.583c.362.154.596.51.596.903v8.613a.986.986 0 01-.986.987H3.27a.986.986 0 01-.986-.987v-8.613c0-.393.232-.748.592-.903 7.737-3.407 18.56-3.407 26.301 0zm-13.15 1.854l-1.035 3.493.96.991 1.1-1.03-1.026-3.454zm11.774 6.676V23.11a30.216 30.216 0 00-8.833-2.03l-1.727.587 1.95 5.322a.986.986 0 01-.469 1.214l-2.805 2.113-2.63-2.13a.986.986 0 01-.439-1.197l1.964-5.322-1.727-.587c-3.03.229-6.007.913-8.833 2.03v6.974h23.549z"
        }), void 0)]
      }, void 0);

    case 'placeholder-dnd':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M26.9999,6 L26.9999,9 L32.9999,9 C34.6569,9 35.9999,10.3435 35.9999,12 L35.9999,12 L35.9999,33 C35.9999,34.6565 34.6569,36 32.9999,36 L32.9999,36 L11.9999,36 C10.3434,36 8.9999,34.6565 8.9999,33 L8.9999,33 L8.9999,27 L5.9999,27 L5.9999,24 L8.9999,24 L8.9999,9 L23.9999,9 L23.9999,6 L26.9999,6 Z M16.2019,15.7015 L19.6929,27.2725 L22.6719,24.2935 L28.3789,30 L30.4999,27.879 L24.7934,22.172 L27.7724,19.193 L16.2019,15.7015 Z M3,24 L3,27 L0,27 L0,24 L3,24 Z M3,18 L3,21 L0,21 L0,18 L3,18 Z M3,12 L3,15 L0,15 L0,12 L3,12 Z M3,6 L3,9 L0,9 L0,6 L3,6 Z M15,0 L15,3 L12,3 L12,0 L15,0 Z M21,0 L21,3 L18,3 L18,0 L21,0 Z M27,0 L27,3 L24,3 L24,0 L27,0 Z M9,0 L9,3 L6,3 L6,0 L9,0 Z M3,0 L3,3 L0,3 L0,0 L3,0 Z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M26.9999,6 L26.9999,9 L32.9999,9 C34.6569,9 35.9999,10.3435 35.9999,12 L35.9999,12 L35.9999,33 C35.9999,34.6565 34.6569,36 32.9999,36 L32.9999,36 L11.9999,36 C10.3434,36 8.9999,34.6565 8.9999,33 L8.9999,33 L8.9999,27 L5.9999,27 L5.9999,24 L8.9999,24 L8.9999,9 L23.9999,9 L23.9999,6 L26.9999,6 Z M16.2019,15.7015 L19.6929,27.2725 L22.6719,24.2935 L28.3789,30 L30.4999,27.879 L24.7934,22.172 L27.7724,19.193 L16.2019,15.7015 Z M3,24 L3,27 L0,27 L0,24 L3,24 Z M3,18 L3,21 L0,21 L0,18 L3,18 Z M3,12 L3,15 L0,15 L0,12 L3,12 Z M3,6 L3,9 L0,9 L0,6 L3,6 Z M15,0 L15,3 L12,3 L12,0 L15,0 Z M21,0 L21,3 L18,3 L18,0 L21,0 Z M27,0 L27,3 L24,3 L24,0 L27,0 Z M9,0 L9,3 L6,3 L6,0 L9,0 Z M3,0 L3,3 L0,3 L0,0 L3,0 Z"
        }), void 0)]
      }, void 0);

    case 'plus':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M14,14 L14,0 L18,0 L18,14 L32,14 L32,18 L18,18 L18,32 L14,32 L14,18 L0,18 L0,14 L14,14 Z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M15,15 L15,0 L17,0 L17,15 L32,15 L32,17 L17,17 L17,32 L15,32 L15,17 L0,17 L0,15 L15,15 Z"
        }), void 0)]
      }, void 0);

    case 'powerbi':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M0,2.01315068 L0,30.0131507 C0,31.1177202 0.8954305,32.0131507 2,32.0131507 L30,32.0131507 C31.1045695,32.0131507 32,31.1177202 32,30.0131507 L32,2.01315068 C32,0.908581185 31.1045695,0.0131506849 30,0.0131506849 L2,0.0131506849 C0.8954305,0.0131506849 0,0.908581185 0,2.01315068 Z M29.9866667,2.01315068 L29.9866667,30.0131507 L1.98666667,30.0131507 L1.98666667,2.01315068 L29.9866667,2.01315068 Z M8.98666667,19.3775951 L3.55555556,19.3775951 L3.55555556,28.2398174 L8.98666667,28.2398174 L8.98666667,19.3775951 Z M15.4888889,11.7109285 L10.0533333,11.7109285 L10.0533333,28.2398174 L15.4888889,28.2398174 L15.4888889,11.7109285 Z M21.9955556,16.8887062 L16.5555556,16.8887062 L16.5555556,28.2398174 L21.9955556,28.2398174 L21.9955556,16.8887062 Z M28.5022222,6.74648402 L23.0622222,6.74648402 L23.0622222,28.2398174 L28.5022222,28.2398174 L28.5022222,6.74648402 Z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M0,2.01315068 L0,30.0131507 C0,31.1177202 0.8954305,32.0131507 2,32.0131507 L30,32.0131507 C31.1045695,32.0131507 32,31.1177202 32,30.0131507 L32,2.01315068 C32,0.908581185 31.1045695,0.0131506849 30,0.0131506849 L2,0.0131506849 C0.8954305,0.0131506849 0,0.908581185 0,2.01315068 Z M29.9866667,2.01315068 L29.9866667,30.0131507 L1.98666667,30.0131507 L1.98666667,2.01315068 L29.9866667,2.01315068 Z M8.98666667,19.3775951 L3.55555556,19.3775951 L3.55555556,28.2398174 L8.98666667,28.2398174 L8.98666667,19.3775951 Z M15.4888889,11.7109285 L10.0533333,11.7109285 L10.0533333,28.2398174 L15.4888889,28.2398174 L15.4888889,11.7109285 Z M21.9955556,16.8887062 L16.5555556,16.8887062 L16.5555556,28.2398174 L21.9955556,28.2398174 L21.9955556,16.8887062 Z M28.5022222,6.74648402 L23.0622222,6.74648402 L23.0622222,28.2398174 L28.5022222,28.2398174 L28.5022222,6.74648402 Z"
        }), void 0)]
      }, void 0);

    case 'powerbi-new':
      return (0, jsx_runtime_1.jsxs)("g", __assign({
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M29.333 0A2.667 2.667 0 0132 2.667v26.666A2.667 2.667 0 0129.333 32H2.667A2.667 2.667 0 010 29.333V2.667A2.667 2.667 0 012.667 0zM26 8h-3v19h3V8zm-6 6h-3v13h3V14zm-5-3h-3v16h3V11zm-6 5H6v11h3V16z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M29.333 0A2.667 2.667 0 0132 2.667v26.666A2.667 2.667 0 0129.333 32H2.667A2.667 2.667 0 010 29.333V2.667A2.667 2.667 0 012.667 0h26.666zM30 2H2v28h28V2zM9 16v9H6v-9h3zm6-5v14h-3V11h3zm5 2v12h-3V13h3zm6-5v17h-3V8h3z"
        }), void 0)]
      }), void 0);

    case 'powerbi-report':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M29.333 0A2.667 2.667 0 0132 2.667v26.666A2.667 2.667 0 0129.333 32H18.667L16 28H0V2.667A2.667 2.667 0 012.667 0zM15 11h-3v11h3V11zm11-3h-3v13h3V8zm-6 5h-3v8h3v-8zM9 16H6v5h3v-5z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M29.333 0A2.667 2.667 0 0132 2.667v26.666A2.667 2.667 0 0129.333 32H2.667A2.667 2.667 0 010 29.333V2.667A2.667 2.667 0 012.667 0h26.666zM29 2H2v22.95h13.5L18.2 29H29V2zM9 16v5H6v-5h3zm6-5v11h-3V11h3zm5 2v8h-3v-8h3zm6-5v13h-3V8h3z"
        }), void 0)]
      }, void 0);

    case 'powerpoint':
      return (0, jsx_runtime_1.jsxs)("g", __assign({
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M15 27l6.5-14L28 27H15zM4 12.5a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0zM29.333 0H2.667A2.667 2.667 0 000 2.667v26.666A2.667 2.667 0 002.667 32h26.666A2.667 2.667 0 0032 29.333V2.667A2.667 2.667 0 0029.333 0z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M29.333 0A2.667 2.667 0 0132 2.667v26.666A2.667 2.667 0 0129.333 32H2.667A2.667 2.667 0 010 29.333V2.667A2.667 2.667 0 012.667 0h26.666zM30 2H2v28h28V2zm-8.5 11L28 27H15l6.5-14zm-11-7a6.5 6.5 0 110 13 6.5 6.5 0 010-13z"
        }), void 0)]
      }), void 0);

    case 'refresh':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M18.667 3a2 2 0 000 4C23.813 7 28 11.187 28 16.333c0 5.147-4.187 9.334-9.333 9.334-5.147 0-9.334-4.187-9.334-9.334v-3.838l1.92 1.92c.39.39.902.585 1.414.585a2 2 0 001.414-3.414L7.333 4.838.586 11.586a2 2 0 002.828 2.828l1.92-1.919v3.838c0 7.352 5.98 13.334 13.333 13.334C26.019 29.667 32 23.685 32 16.333 32 8.981 26.019 3 18.667 3"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M18.667 3a1.333 1.333 0 100 2.667c5.881 0 10.666 4.785 10.666 10.666C29.333 22.215 24.548 27 18.667 27 12.785 27 8 22.215 8 16.333V10.22l3.057 3.057c.26.26.602.39.943.39a1.333 1.333 0 00.943-2.276L6.667 5.116.39 11.39a1.333 1.333 0 101.885 1.885l3.057-3.057v6.114c0 7.352 5.982 13.334 13.334 13.334C26.019 29.667 32 23.685 32 16.333 32 8.981 26.019 3 18.667 3"
        }), void 0)]
      }, void 0);

    case 'report':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M26.667 20.333V23h-9.334v-2.667h9.334zM29.333 15v2.667h-12V15h12zm0-5.333v2.666h-12V9.667h12zM8 20.333A5.334 5.334 0 018 9.667V15h5.334A5.334 5.334 0 018 20.333zM9.333 9.842a5.33 5.33 0 013.825 3.825H9.333V9.842zM0 3v24a2.667 2.667 0 002.667 2.667h26.666A2.667 2.667 0 0032 27V3H0z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M32 3v24a2.667 2.667 0 01-2.667 2.667H2.667A2.667 2.667 0 010 27V3h32zm-2.667 2.667H2.667V27h26.666V5.667zm-4 14.666V23h-6.666v-2.667h6.666zM10.667 9.667V15H16a5.334 5.334 0 11-5.333-5.333zm16 5.333v2.667h-8V15h8zM12 9.842a5.332 5.332 0 013.825 3.824H12V9.842zm14.667-.175v2.666h-8V9.667h8z"
        }), void 0)]
      }, void 0);

    case 'rich-text-editor':
    case 'richtexteditor':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M10 18l4 4L29 7v23.067A1.933 1.933 0 0127.067 32H0V4.933C0 3.865.866 3 1.933 3H25L10 18zm-2 6h4l-4-4v4zM28 0l4 4-3 3-4-4 3-3z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M28.066 30.026l-.025-17.681H30v17.72c0 1.07-.866 1.935-1.934 1.935H0V3.934C0 2.866.866 2 1.934 2h17.7v1.974h-17.7l.035 26.052h26.097zM12.638 17.953l2-2 1.413 1.415-1.999 2-1.414-1.415zM30.586 0L32 1.415l-1.593 1.592-1 1L27.413 6l-1.005 1.006-8.904 8.908L16.09 14.5l8.907-8.91 1-1 1.999-2 1-1L30.586 0z"
        }), void 0)]
      }, void 0);

    case 'search':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M12 19.556c-4.166 0-7.556-3.39-7.556-7.556S7.834 4.444 12 4.444s7.556 3.39 7.556 7.556a7.465 7.465 0 01-1.519 4.54l-1.498 1.497A7.465 7.465 0 0112 19.556zm20 9.616L21.773 18.945A11.925 11.925 0 0024 12c0-6.628-5.372-12-12-12S0 5.372 0 12s5.372 12 12 12c2.591 0 4.984-.83 6.945-2.227L29.172 32 32 29.172z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M12 21.333c-5.146 0-9.333-4.187-9.333-9.333S6.854 2.667 12 2.667 21.333 6.854 21.333 12 17.146 21.333 12 21.333zm20 8.782L21.374 19.488A11.95 11.95 0 0024 12c0-6.628-5.372-12-12-12S0 5.372 0 12s5.372 12 12 12a11.95 11.95 0 007.488-2.626L30.115 32 32 30.115z"
        }), void 0)]
      }, void 0);

    case 'search-error':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M17.61 15.724l-1.886 1.885-3.812-3.812L8.1 17.61l-1.878-1.877 3.813-3.812-3.813-3.812 1.886-1.886 3.812 3.812 3.812-3.812L17.609 8.1l-3.812 3.812 3.812 3.812zm4.163 3.22A11.93 11.93 0 0024 12c0-6.628-5.372-12-12-12S0 5.372 0 12s5.372 12 12 12c2.591 0 4.984-.83 6.944-2.227L29.172 32 32 29.172 21.773 18.945z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M12 0c6.628 0 12 5.372 12 12 0 2.833-.984 5.435-2.626 7.488L32 30.115 30.114 32 19.488 21.374A11.947 11.947 0 0112 24C5.372 24 0 18.628 0 12S5.372 0 12 0zm0 2.667c-5.147 0-9.333 4.187-9.333 9.333S6.853 21.333 12 21.333s9.333-4.187 9.333-9.333S17.147 2.667 12 2.667zm3.732 3.555L17.61 8.1l-3.813 3.812 3.813 3.812-1.886 1.885-3.812-3.812-3.813 3.812-1.877-1.877 3.812-3.812-3.812-3.812 1.886-1.886 3.812 3.812 3.812-3.812z"
        }), void 0)]
      }, void 0);

    case 'settings':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M16 20.065c-2.205 0-4-1.823-4-4.065 0-2.242 1.795-4.065 4-4.065 2.206 0 4 1.823 4 4.065 0 2.242-1.794 4.065-4 4.065m14.419-9.212l-2.253-.396a13.567 13.567 0 00-1.36-2.391l.79-2.182a1.822 1.822 0 00-.74-2.29L21.144.242A1.75 1.75 0 0020.256 0c-.548 0-1.087.258-1.433.736L17.361 2.52a13.422 13.422 0 00-2.722 0L13.177.736A1.767 1.767 0 0011.744 0a1.75 1.75 0 00-.888.242L5.144 3.594a1.822 1.822 0 00-.74 2.29l.79 2.182c-.53.744-.986 1.544-1.36 2.391l-2.253.396c-.9.102-1.581.875-1.581 1.796v6.702c0 .921.681 1.694 1.581 1.796l2.253.396c.374.847.83 1.647 1.36 2.391l-.79 2.182a1.822 1.822 0 00.74 2.29l5.712 3.352c.279.163.585.242.888.242.548 0 1.087-.258 1.433-.736l1.462-1.783a13.422 13.422 0 002.722 0l1.462 1.783c.346.478.885.736 1.433.736.303 0 .61-.079.888-.242l5.712-3.352a1.822 1.822 0 00.74-2.29l-.79-2.182c.53-.744.986-1.544 1.36-2.391l2.253-.396A1.797 1.797 0 0032 19.351V12.65c0-.921-.681-1.694-1.581-1.796"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M20.256 0c.304 0 .61.079.888.242l5.712 3.352a1.821 1.821 0 01.74 2.29l-.79 2.181c.53.745.986 1.545 1.36 2.392l2.253.396c.9.102 1.581.875 1.581 1.796v6.702c0 .921-.68 1.694-1.581 1.796l-2.253.395c-.374.848-.83 1.648-1.36 2.392l.79 2.182c.363.844.044 1.83-.74 2.29l-5.712 3.352c-.279.163-.584.242-.888.242a1.768 1.768 0 01-1.433-.736l-1.462-1.783a13.415 13.415 0 01-2.722 0l-1.462 1.783a1.767 1.767 0 01-1.433.736c-.303 0-.609-.079-.888-.242l-5.712-3.352a1.821 1.821 0 01-.74-2.29l.79-2.182a13.555 13.555 0 01-1.36-2.392l-2.253-.395A1.796 1.796 0 010 19.35V12.65c0-.921.681-1.694 1.581-1.796l2.253-.396c.374-.847.83-1.647 1.36-2.392l-.79-2.182a1.821 1.821 0 01.74-2.29l5.712-3.35c.28-.164.585-.243.888-.243.549 0 1.087.258 1.433.736l1.462 1.783a13.429 13.429 0 012.722 0L18.823.736A1.767 1.767 0 0120.256 0zm.206 2.971L19.41 4.254l-.907 1.107-1.41-.145a10.737 10.737 0 00-2.185 0l-1.41.145-.908-1.107-1.052-1.283-4.41 2.588.57 1.57.49 1.355-.833 1.17c-.425.597-.791 1.24-1.088 1.913l-.581 1.315-1.398.246-1.621.284v5.175l1.621.285 1.397.245.582 1.315c.297.673.663 1.317 1.088 1.914l.833 1.17-.49 1.355-.57 1.57 4.41 2.588 1.052-1.283.907-1.107 1.411.145a10.728 10.728 0 002.184 0l1.41-.145.908 1.107 1.052 1.283 4.41-2.588-.57-1.57-.49-1.355.833-1.17c.425-.597.791-1.24 1.089-1.914l.58-1.315 1.398-.245 1.621-.285v-5.175l-1.62-.284-1.398-.246-.581-1.315a10.88 10.88 0 00-1.089-1.913l-.833-1.17.49-1.355.57-1.57-4.41-2.588zM16 9.225c3.682 0 6.667 3.033 6.667 6.775 0 3.742-2.985 6.775-6.667 6.775S9.333 19.742 9.333 16c0-3.742 2.985-6.775 6.667-6.775zm0 2.71c-2.205 0-4 1.823-4 4.065 0 2.242 1.795 4.065 4 4.065s4-1.823 4-4.065c0-2.242-1.795-4.065-4-4.065z"
        }), void 0)]
      }, void 0);

    case 'show':
    case 'view':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M15.983 4c5.044 0 8.956 3.834 12.117 7.584a118.606 118.606 0 003.07 3.513L32 16l-.83.903c-.014.014-1.33 1.447-3.07 3.513C24.939 24.166 21.027 28 15.983 28c-5.044 0-8.956-3.834-12.118-7.584a118.606 118.606 0 00-3.069-3.513L0 16l.796-.903c.013-.014 1.33-1.447 3.07-3.513C7.025 7.834 10.938 4 15.982 4zM16 8a8 8 0 100 16 8 8 0 000-16zm0 2.667A5.34 5.34 0 0121.333 16 5.34 5.34 0 0116 21.333 5.34 5.34 0 0110.667 16c0-1.614.723-3.06 1.859-4.038L16 15.436v-4.77z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M15.983 4c5.044 0 8.956 3.834 12.117 7.584a119.689 119.689 0 003.07 3.512L32 16l-.83.903c-.014.014-1.33 1.447-3.07 3.512C24.939 24.165 21.027 28 15.983 28c-5.044 0-8.956-3.834-12.117-7.585a118.448 118.448 0 00-3.07-3.512L0 16l.796-.904c.014-.014 1.33-1.447 3.07-3.512C7.027 7.834 10.939 4 15.983 4zm0 2.667c-3.954 0-7.315 3.355-10.081 6.637A135.564 135.564 0 013.57 16c.563.633 1.38 1.566 2.332 2.696 2.766 3.282 6.127 6.637 10.08 6.637 3.954 0 7.315-3.355 10.082-6.637.952-1.13 1.769-2.063 2.332-2.696-.563-.633-1.38-1.567-2.332-2.696-2.767-3.282-6.128-6.637-10.081-6.637zM16 9.333A6.674 6.674 0 0122.667 16 6.674 6.674 0 0116 22.666 6.674 6.674 0 019.334 16 6.674 6.674 0 0116 9.333zM16 12c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4z"
        }), void 0)]
      }, void 0);

    case 'tag':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M30.22 0C31.203 0 32 .797 32 1.78V13.2c0 .472-.187.925-.521 1.258l-16.76 16.76a2.663 2.663 0 01-1.888.782c-.683 0-1.366-.26-1.888-.782L.782 21.056a2.67 2.67 0 010-3.775L17.542.52A1.78 1.78 0 0118.8 0h11.42zm-5.562 4.005a3.337 3.337 0 100 6.674 3.337 3.337 0 000-6.674z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M30.22 0C31.203 0 32 .797 32 1.78V13.2c0 .472-.187.925-.521 1.258l-16.76 16.76a2.663 2.663 0 01-1.888.782c-.683 0-1.366-.26-1.888-.782L.782 21.056a2.67 2.67 0 010-3.775L17.542.52A1.78 1.78 0 0118.8 0h11.42zm-.89 2.67H19.17l-16.5 16.499L12.832 29.33l16.5-16.499V2.67zm-5.34 2.67a2.67 2.67 0 110 5.34 2.67 2.67 0 010-5.34z"
        }), void 0)]
      }, void 0);

    case 'text':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M30.667 26v4H0v-4h30.667zm-8-8v4H0v-4h22.667zM32 10v4H0v-4h32zM18.667 2v4H0V2h18.667z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M30.667 27v2.667H0V27h30.667zm-8.445-8v2.667H0V19h22.222zM32 11v2.667H0V11h32zM18.667 3v2.667H0V3h18.667z"
        }), void 0)]
      }, void 0);

    case 'textbox':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M26.667 0v1.333H5.333V0H0v5.333h1.333v21.334H0V32h5.333v-1.333h21.334V32H32v-5.333h-1.333V5.333H32V0h-5.333zM8 6h16v5.429h-5.333V25h-5.334V11.429H8V6z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M5.333 0v1.333h21.334V0H32v5.333h-1.333v21.334H32V32h-5.333v-1.333H5.333V32H0v-5.333h1.333V5.333H0V0h5.333zm21.334 4H5.333v1.333H4v21.334h1.333V28h21.334v-1.333H28V5.333h-1.333V4zM22 8v2.667h-5.2V24h-2.6V10.667H9V8h13z"
        }), void 0)]
      }, void 0);

    case 'thumbs-up':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M4.712 12.402H1.064a1.038 1.038 0 00-.76.307c-.202.203-.311.48-.304.766v16.838c-.007.286.102.563.303.766.201.203.476.314.761.307h1.82c1.6 0 2.897-1.302 2.897-2.91V13.485a1.057 1.057 0 00-.304-.77 1.047 1.047 0 00-.765-.312zm24.39.764h-4.417a3.002 3.002 0 01-2.897-2.905V2.91A3.006 3.006 0 0018.89 0h-1.828a1.038 1.038 0 00-.764.306c-.203.203-.313.48-.305.767V5.51c0 3.828-2.743 7.656-6.251 7.656a1.038 1.038 0 00-.764.305c-.202.203-.313.48-.305.768v14.547c-.006.286.104.562.306.764.202.202.478.312.763.304C14.622 30.01 16.273 32 21.48 32 26.97 32 32 31.386 32 25.108v-9.183c0-1.377-1.372-2.76-2.897-2.76z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M18.72 0a3.804 3.804 0 013.698 3.723v6.889a1.83 1.83 0 001.733 1.74h4.147c1.938 0 3.702 1.706 3.702 3.572v8.616C32 32 24.942 32 21.147 32a16.67 16.67 0 01-5.876-1.045 14.93 14.93 0 00-4.426-.94L10.542 30a1.956 1.956 0 01-1.39-.586 1.975 1.975 0 01-.566-1.405v-13.66a1.979 1.979 0 01.576-1.418 1.96 1.96 0 011.411-.578c2.743 0 4.445-3.215 4.445-6.192V1.996a1.978 1.978 0 01.575-1.418A1.961 1.961 0 0117.004 0h1.716zM5.418 11.634a1.966 1.966 0 011.41.58c.373.374.581.885.576 1.415v14.076a3.715 3.715 0 01-3.702 3.72H1.987a1.961 1.961 0 01-1.412-.579A1.978 1.978 0 010 29.428V13.63a1.978 1.978 0 01.575-1.417 1.961 1.961 0 011.412-.578h3.43zM17 1.978V6.16c0 5.116-3.262 8.17-6.413 8.17v13.664h.044c1.806.065 3.59.42 5.285 1.054 1.68.637 3.461.962 5.257.96 5.778 0 8.89-.893 8.89-5.478V15.93a1.834 1.834 0 00-1.734-1.599H24.15a3.804 3.804 0 01-3.707-3.718V3.723a1.83 1.83 0 00-1.733-1.74L17 1.977zM1.987 13.612v15.816H3.72a1.742 1.742 0 001.733-1.74V13.628l-3.466-.017z"
        }), void 0)]
      }, void 0);

    case 'thumbs-down':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M4.712 19.598H1.064a1.038 1.038 0 01-.76-.307A1.047 1.047 0 010 18.525V1.687A1.047 1.047 0 01.303.92C.504.718.78.607 1.064.614h1.82c1.6 0 2.897 1.302 2.897 2.91v14.992c.007.287-.102.566-.304.77a1.047 1.047 0 01-.765.312zm24.39-.764h-4.417a3.002 3.002 0 00-2.897 2.905v7.351A3.006 3.006 0 0118.89 32h-1.828a1.038 1.038 0 01-.764-.306 1.047 1.047 0 01-.305-.767V26.49c0-3.828-2.743-7.656-6.251-7.656a1.038 1.038 0 01-.764-.305 1.047 1.047 0 01-.305-.768V3.214a1.047 1.047 0 01.306-.764c.202-.202.478-.312.763-.304C14.622 1.99 16.273 0 21.48 0 26.97 0 32 .614 32 6.892v9.183c0 1.377-1.372 2.76-2.897 2.76z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M18.72 32a3.804 3.804 0 003.698-3.723v-6.889a1.83 1.83 0 011.733-1.74h4.147c1.938 0 3.702-1.706 3.702-3.572V7.46C32 0 24.942 0 21.147 0a16.67 16.67 0 00-5.876 1.045 14.93 14.93 0 01-4.426.941L10.542 2a1.956 1.956 0 00-1.39.586c-.368.374-.571.88-.565 1.405v13.66a1.979 1.979 0 00.575 1.418 1.96 1.96 0 001.411.578c2.743 0 4.445 3.214 4.445 6.192v4.165a1.978 1.978 0 00.575 1.418c.374.375.883.584 1.412.578h1.715zM5.418 20.366a1.966 1.966 0 001.41-.58c.374-.374.581-.885.577-1.416V4.295A3.715 3.715 0 003.702.576H1.987a1.961 1.961 0 00-1.412.578A1.978 1.978 0 000 2.572V18.37a1.978 1.978 0 00.575 1.418c.374.376.883.584 1.412.578h3.43zM17 30.022v-4.183c0-5.116-3.262-8.17-6.413-8.17V4.006h.044c1.807-.065 3.59-.42 5.285-1.054a14.778 14.778 0 015.257-.96c5.778 0 8.89.893 8.89 5.478v8.602a1.834 1.834 0 01-1.734 1.599H24.15a3.804 3.804 0 00-3.707 3.718v6.889a1.83 1.83 0 01-1.733 1.74l-1.71.005zM1.987 18.388V2.572H3.72c.956.002 1.731.78 1.733 1.74V18.37l-3.466.018z"
        }), void 0)]
      }, void 0);

    case 'time':
    case 'clock':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M32 16c0 8.836-7.164 16-16 16S0 24.836 0 16 7.164 0 16 0s16 7.164 16 16zm-6 2v-4.027h-7.973V6H14v12h12z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M16 0c8.836 0 16 7.164 16 16s-7.164 16-16 16C7.163 32 0 24.836 0 16S7.163 0 16 0zm0 30c7.72 0 14-6.28 14-14S23.72 2 16 2 2 8.28 2 16s6.28 14 14 14zm1-15h8.92v2H15V6.08h2V15z"
        }), void 0)]
      }, void 0);

    case 'transfer':
    case 'change':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M11.219 10.667l3.057 3.057a1.333 1.333 0 11-1.885 1.885L6.115 9.333l6.276-6.276a1.333 1.333 0 111.885 1.886L11.219 8H32V0H2.667A2.667 2.667 0 000 2.667v18.666h20.781l-3.057-3.057a1.333 1.333 0 111.885-1.885l6.276 6.276-6.276 6.276a1.33 1.33 0 01-1.885 0 1.333 1.333 0 010-1.886L20.781 24H0v5.333A2.667 2.667 0 002.667 32h26.666A2.667 2.667 0 0032 29.333V10.667H11.219z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M32 0v29.333A2.667 2.667 0 0129.333 32H2.667A2.667 2.667 0 010 29.333V2.667A2.667 2.667 0 012.667 0H32zm-2.667 2.667H2.667V20H20.78l-3.056-3.057a1.333 1.333 0 111.885-1.886l6.277 6.276-6.277 6.276a1.328 1.328 0 01-1.885 0 1.333 1.333 0 010-1.885l3.056-3.057H2.667v6.666h26.666V12H11.22l3.057 3.057a1.333 1.333 0 11-1.885 1.886l-6.277-6.276 6.277-6.276a1.333 1.333 0 111.885 1.885l-3.057 3.057h18.114V2.667z"
        }), void 0)]
      }, void 0);

    case 'unlocked':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M16 0c4.473 0 8.1 3.681 8.1 8.222v2.445h2.7c1.49 0 2.7 1.194 2.7 2.666v16c0 1.473-1.21 2.667-2.7 2.667H5.2c-1.49 0-2.7-1.194-2.7-2.667v-16c0-1.472 1.21-2.666 2.7-2.666h16.2V8.222c0-3.063-2.422-5.555-5.4-5.555-2.26 0-4.199 1.438-5.002 3.47L8.644 4.797C9.925 1.968 12.733 0 16 0zm1.5 17h-3v8h3v-8z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M16.333 0c4.419 0 8 3.681 8 8.222v2.445H27a2.667 2.667 0 012.667 2.666v16A2.667 2.667 0 0127 32H5.667A2.667 2.667 0 013 29.333v-16a2.667 2.667 0 012.667-2.666h16V8.222c0-3.063-2.393-5.555-5.334-5.555-2.233 0-4.147 1.438-4.94 3.47L9.068 4.797C10.333 1.968 13.107 0 16.333 0zM27 13.333H5.667v16H27v-16zm-9.333 4v8H15v-8h2.667z"
        }), void 0)]
      }, void 0);

    case 'upload':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M14,24 L14,12.8266667 L10.4755556,16.3511111 C9.68752955,17.0854015 8.45952963,17.0637348 7.69789743,16.3021025 C6.93626521,15.5404704 6.9145986,14.3124704 7.64888889,13.5244444 L14.5822223,6.58666667 L14.5822223,6.58666667 L16,5.17333333 L17.4133333,6.58666667 L17.4133333,6.58666667 L24.3511111,13.5244444 C24.8861863,14.0230327 25.1064423,14.7739259 24.9254725,15.4825483 C24.7445028,16.1911705 24.1911705,16.7445028 23.4825483,16.9254725 C22.7739259,17.1064423 22.0230327,16.8861863 21.5244444,16.3511111 L18,12.8266667 L18,24 L32,24 L32,1.33333333 C32,0.596953667 31.4030463,0 30.6666667,0 L1.33333333,0 C0.596953667,0 0,0.596953667 0,1.33333333 L0,24 L14,24 Z M14,24 L14,32 L18,32 L18,24 L14,24 Z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M14,24 L14,12.8266667 L10.4755556,16.3511111 C9.68752955,17.0854015 8.45952963,17.0637348 7.69789743,16.3021025 C6.93626521,15.5404704 6.9145986,14.3124704 7.64888889,13.5244444 L14.5822223,6.58666667 L14.5822223,6.58666667 L16,5.17333333 L17.4133333,6.58666667 L17.4133333,6.58666667 L24.3511111,13.5244444 C24.8861863,14.0230327 25.1064423,14.7739259 24.9254725,15.4825483 C24.7445028,16.1911705 24.1911705,16.7445028 23.4825483,16.9254725 C22.7739259,17.1064423 22.0230327,16.8861863 21.5244444,16.3511111 L18,12.8266667 L18,24 L32,24 L32,1.33333333 C32,0.596953667 31.4030463,0 30.6666667,0 L1.33333333,0 C0.596953667,0 0,0.596953667 0,1.33333333 L0,24 L14,24 Z M14,24 L14,32 L18,32 L18,24 L14,24 Z"
        }), void 0)]
      }, void 0);

    case 'view-off':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M26.168 4l1.886 1.885L5.832 28.108l-1.886-1.886L26.168 4zm.09 5.566a47.873 47.873 0 011.842 2.072 118.89 118.89 0 003.07 3.512l.83.903-.83.904c-.014.014-1.33 1.447-3.07 3.512-3.161 3.75-7.073 7.585-12.117 7.585-2.29 0-4.344-.795-6.204-2.009l2.78-2.78a7.94 7.94 0 003.44.789c4.412 0 8-3.59 8-8a7.94 7.94 0 00-.788-3.441l3.048-3.047zM15.984 4.054c2.298 0 4.36.8 6.223 2.022l-2.765 2.766A7.94 7.94 0 0016 8.054c-4.412 0-8 3.588-8 8a7.94 7.94 0 00.788 3.44L5.723 22.56a47.568 47.568 0 01-1.858-2.09 119.69 119.69 0 00-3.069-3.512L0 16.054l.796-.903c.013-.015 1.33-1.448 3.07-3.513 3.16-3.75 7.072-7.584 12.117-7.584zm5.164 10.624c.117.44.186.9.186 1.376A5.34 5.34 0 0116 21.387c-.477 0-.936-.069-1.376-.187l6.523-6.522zM16 10.72c.476 0 .936.069 1.376.187l-6.523 6.523c-.118-.44-.186-.9-.186-1.376A5.34 5.34 0 0116 10.72z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M26.064 18.75c-2.767 3.282-6.128 6.638-10.081 6.638-1.944 0-3.744-.814-5.402-2.03l1.747-1.746A6.622 6.622 0 0016 22.721a6.674 6.674 0 006.667-6.667c0-1.357-.41-2.618-1.108-3.673l1.878-1.878c.928.899 1.804 1.88 2.627 2.855.952 1.13 1.769 2.063 2.332 2.696-.563.633-1.38 1.566-2.332 2.696zM12 16.054c0-2.206 1.795-4 4-4 .616 0 1.199.144 1.72.394l-5.325 5.326a3.967 3.967 0 01-.395-1.72zm8 0c0 2.206-1.794 4-4 4a3.973 3.973 0 01-1.72-.394l5.326-5.326c.25.522.394 1.104.394 1.72zM5.902 18.75a134.042 134.042 0 00-2.332-2.696c.563-.633 1.38-1.566 2.332-2.696 2.766-3.282 6.127-6.637 10.08-6.637 1.953 0 3.76.82 5.423 2.043l-1.732 1.732A6.622 6.622 0 0016 9.388a6.674 6.674 0 00-6.667 6.666c0 1.357.41 2.618 1.109 3.673l-1.896 1.895c-.934-.903-1.816-1.89-2.644-2.872zm25.267-3.6c-.013-.014-1.329-1.446-3.069-3.511a41.708 41.708 0 00-2.78-3.02l2.734-2.733L26.168 4l-2.86 2.86c-2.145-1.654-4.564-2.806-7.325-2.806-5.044 0-8.956 3.834-12.117 7.585a118.449 118.449 0 01-3.07 3.512L0 16.054l.796.903c.014.015 1.33 1.447 3.07 3.512a41.437 41.437 0 002.797 3.037l-2.717 2.716 1.886 1.886 2.846-2.846c2.14 1.646 4.553 2.792 7.305 2.792 5.044 0 8.956-3.834 12.117-7.585a119.689 119.689 0 013.07-3.512l.83-.903-.83-.903z"
        }), void 0)]
      }, void 0);

    case 'wait':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M28 0v2.667h-2.667v6.077c0 1.63-.73 3.147-2.001 4.165l-.118.084-4.732 3.009 4.85 3.09a5.308 5.308 0 012.001 4.164v6.077H28V32H4v-2.667h2.667v-6.077c0-1.63.73-3.147 2.001-4.165l.118-.083 4.732-3.01-4.85-3.09a5.308 5.308 0 01-2.001-4.164V2.667H4V0h24zM16 17.58l-5.716 3.635a2.65 2.65 0 00-.95 2.04v6.078h13.333v-6.077a2.65 2.65 0 00-.951-2.04L16 17.58zm0 3.16l3.385 2.153c.386.245.619.67.618 1.126l-.002 2.648H12v-2.651c0-.456.233-.88.618-1.125L16 20.74zm6.667-18.073H9.333v6.077c0 .793.346 1.533.951 2.041L16 14.42l5.716-3.635c.605-.508.95-1.248.95-2.04V2.666zM20 5.334v2.65c0 .456-.233.88-.618 1.125L16 11.26l-3.385-2.153a1.333 1.333 0 01-.618-1.126l.002-2.647h8z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "outline",
          d: "M21.716 10.785L16 14.42l-5.716-3.635a2.653 2.653 0 01-.95-2.04V2.666h13.333v6.077c0 .793-.346 1.533-.951 2.041zm0 10.43c.605.508.95 1.248.95 2.041v6.077H9.334v-6.077c0-.793.346-1.533.95-2.04L16 17.58l5.716 3.635zm1.616-8.306a5.308 5.308 0 002.001-4.165V2.667H28V0H4v2.667h2.667v6.077c0 1.63.729 3.147 2.001 4.165l4.85 3.09-4.732 3.009-.118.083a5.308 5.308 0 00-2.001 4.165v6.077H4V32h24v-2.667h-2.667v-6.077a5.31 5.31 0 00-2.001-4.165l-4.85-3.09 4.732-3.008.118-.084z"
        }), void 0)]
      }, void 0);

    case 'pause':
      return (0, jsx_runtime_1.jsx)("g", {
        children: (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M 0 31 L 0 0 L 9.816406 0 L 9.816406 31 Z M 17.183594 31 L 17.183594 0 L 27 0 L 27 31 Z M 17.183594 31"
        }), void 0)
      }, void 0);

    case 'archive':
      return (0, jsx_runtime_1.jsx)("g", {
        children: (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M 18.199219 10.667969 L 7.800781 10.667969 L 7.800781 8 C 7.800781 5.058594 10.132812 2.667969 13 2.667969 C 15.867188 2.667969 18.199219 5.058594 18.199219 8 Z M 11.699219 25.332031 L 14.300781 25.332031 L 14.300781 17.332031 L 11.699219 17.332031 Z M 23.398438 10.667969 L 20.800781 10.667969 L 20.800781 8 C 20.800781 3.582031 17.308594 0 13 0 C 8.691406 0 5.199219 3.582031 5.199219 8 L 5.199219 10.667969 L 2.601562 10.667969 C 1.164062 10.667969 0 11.859375 0 13.332031 L 0 29.332031 C 0 30.804688 1.164062 32 2.601562 32 L 23.398438 32 C 24.835938 32 26 30.804688 26 29.332031 L 26 13.332031 C 26 11.859375 24.835938 10.667969 23.398438 10.667969 Z M 23.398438 10.667969"
        }), void 0)
      }, void 0);

    case '1-col-fw':
      return (0, jsx_runtime_1.jsx)("g", __assign({
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, {
        children: (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M2,0 C0.896,0 0,0.896 0,2 L0,24 C0,25.104 0.896,26 2,26 L36,26 C37.104,26 38,25.104 38,24 L38,2 C38,0.896 37.104,0 36,0 L2,0 Z M2,24 L36,24 L36,2 L2,2 L2,24 Z"
        }), void 0)
      }), void 0);

    case '1-col-l':
      return (0, jsx_runtime_1.jsx)("g", __assign({
        stroke: "none",
        strokeWidth: "1",
        fillRule: "evenodd"
      }, {
        children: (0, jsx_runtime_1.jsxs)("g", {
          children: [(0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
            className: "fill",
            points: "34.0002 4.97379915e-14 34.0002 1.001 36.0002 1.001 36.0002 2.284 37.0002 2.284 37.0002 4.97379915e-14"
          }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
            className: "fill",
            points: "29.0002 1.001 32.0012 1.001 32.0012 9.9475983e-14 29.0002 9.9475983e-14"
          }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
            className: "fill",
            points: "36.0002 7.285 37.0002 7.285 37.0002 4.285 36.0002 4.285"
          }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
            className: "fill",
            points: "36.0002 12.285 37.0002 12.285 37.0002 9.284 36.0002 9.284"
          }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
            className: "fill",
            points: "36.0002 17.285 37.0002 17.285 37.0002 14.285 36.0002 14.285"
          }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
            className: "fill",
            points: "36.0002 22.285 37.0002 22.285 37.0002 19.284 36.0002 19.284"
          }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
            className: "fill",
            points: "34.7152 25 36.9992 25 36.9992 24 34.7152 24"
          }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
            className: "fill",
            points: "29.7162 25 32.7162 25 32.7162 24 29.7162 24"
          }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
            className: "fill",
            d: "M28,0.0004 L2,0.0004 C0.896,0.0004 0,0.8964 0,2.0004 L0,23.0004 C0,24.1044 0.896,25.0004 2,25.0004 L28,25.0004 L28,0.0004 Z M2,23.0004 L26,23.0004 L26,2.0004 L2,2.0004 L2,23.0004 Z"
          }), void 0)]
        }, void 0)
      }), void 0);

    case '1-col-m':
      return (0, jsx_runtime_1.jsxs)("g", __assign({
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, {
        children: [(0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
          className: "fill",
          points: "34.0002 0.0003 34.0002 1.0003 36.0002 1.0003 36.0002 2.2843 37.0002 2.2843 37.0002 0.0003"
        }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
          className: "fill",
          points: "29.0002 1.0003 32.0012 1.0003 32.0012 0.0003 29.0002 0.0003"
        }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
          className: "fill",
          points: "24.0002 1.0003 27.0002 1.0003 27.0002 0.0003 24.0002 0.0003"
        }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
          className: "fill",
          points: "36.0002 7.2843 37.0002 7.2843 37.0002 4.2843 36.0002 4.2843"
        }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
          className: "fill",
          points: "36.0002 12.2843 37.0002 12.2843 37.0002 9.2833 36.0002 9.2833"
        }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
          className: "fill",
          points: "36.0002 17.2843 37.0002 17.2843 37.0002 14.2843 36.0002 14.2843"
        }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
          className: "fill",
          points: "36.0002 22.2843 37.0002 22.2843 37.0002 19.2843 36.0002 19.2843"
        }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
          className: "fill",
          points: "34.7152 24.9993 36.9992 24.9993 36.9992 23.9993 34.7152 23.9993"
        }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
          className: "fill",
          points: "29.7162 24.9993 32.7162 24.9993 32.7162 23.9993 29.7162 23.9993"
        }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
          className: "fill",
          points: "24.7162 24.9993 27.7162 24.9993 27.7162 23.9993 24.7162 23.9993"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M25,0 L2,0 C0.896,0 0,0.896 0,2 L0,23 C0,24.104 0.896,25 2,25 L25,25 L25,0 Z M2,23 L23,23 L23,2 L2,2 L2,23 Z"
        }), void 0)]
      }), void 0);

    case '1-col-s':
      return (0, jsx_runtime_1.jsxs)("g", __assign({
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, {
        children: [(0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
          className: "fill",
          points: "34.0002 0.0001 34.0002 1.0001 36.0002 1.0001 36.0002 2.2841 37.0002 2.2841 37.0002 0.0001"
        }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
          className: "fill",
          points: "29.0002 1.0001 32.0012 1.0001 32.0012 0.0001 29.0002 0.0001"
        }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
          className: "fill",
          points: "24.0002 1.0001 27.0002 1.0001 27.0002 0.0001 24.0002 0.0001"
        }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
          className: "fill",
          points: "19.0002 1.0001 22.0002 1.0001 22.0002 0.0001 19.0002 0.0001"
        }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
          className: "fill",
          points: "36.0002 7.2841 37.0002 7.2841 37.0002 4.2841 36.0002 4.2841"
        }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
          className: "fill",
          points: "36.0002 12.2841 37.0002 12.2841 37.0002 9.2841 36.0002 9.2841"
        }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
          className: "fill",
          points: "36.0002 17.2851 37.0002 17.2851 37.0002 14.2841 36.0002 14.2841"
        }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
          className: "fill",
          points: "36.0002 22.2841 37.0002 22.2841 37.0002 19.2841 36.0002 19.2841"
        }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
          className: "fill",
          points: "34.7152 25.0001 36.9992 25.0001 36.9992 24.0001 34.7152 24.0001"
        }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
          className: "fill",
          points: "29.7162 25.0001 32.7162 25.0001 32.7162 24.0001 29.7162 24.0001"
        }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
          className: "fill",
          points: "24.7162 25.0001 27.7162 25.0001 27.7162 24.0001 24.7162 24.0001"
        }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
          className: "fill",
          points: "19.7152 25.0001 22.7162 25.0001 22.7162 24.0001 19.7152 24.0001"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M19,0 L2,0 C0.896,0 0,0.896 0,2 L0,23 C0,24.104 0.896,25 2,25 L19,25 L19,0 Z M2,23 L17,23 L17,2 L2,2 L2,23 Z"
        }), void 0)]
      }), void 0);

    case '2-col':
      return (0, jsx_runtime_1.jsxs)("g", __assign({
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M18,0 L18,26 L36,26 C37.104,26 38,25.06816 38,23.92 L38,2.08 C38,0.93184 37.104,0 36,0 L18,0 Z M20,24 L36,24 L36,2 L20,2 L20,24 Z"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          className: "fill",
          d: "M20,0 L2,0 C0.896,0 0,0.93184 0,2.08 L0,23.92 C0,25.06816 0.896,26 2,26 L20,26 L20,0 Z M2,24 L18,24 L18,2 L2,2 L2,24 Z"
        }), void 0)]
      }), void 0);

    case '2-col-text':
      return (0, jsx_runtime_1.jsxs)("g", __assign({
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, {
        children: [(0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
          className: "fill",
          points: "19 6 20 6 20 3 19 3"
        }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
          className: "fill",
          points: "19 11 20 11 20 8 19 8"
        }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
          className: "fill",
          points: "19 16 20 16 20 13 19 13"
        }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
          className: "fill",
          points: "19 21 20 21 20 17.999 19 17.999"
        }), void 0), (0, jsx_runtime_1.jsx)("polygon", __assign({}, props, {
          className: "fill",
          points: "19 23 19 24 19 25 20 25 20 23"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          d: "M2,0 C0.896,0 0,0.896 0,2 L0,24 C0,25.104 0.896,26 2,26 L36,26 C37.104,26 38,25.104 38,24 L38,2 C38,0.896 37.104,0 36,0 L2,0 Z M2,24 L36,24 L36,2 L2,2 L2,24 Z",
          className: "fill"
        }), void 0)]
      }), void 0);

    case '2-col-narrow-r':
      return (0, jsx_runtime_1.jsxs)("g", __assign({
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({
          d: "M26,0 L2,0 C0.896,0 0,0.93184 0,2.08 L0,23.92 C0,25.06816 0.896,26 2,26 L26,26 L26,0 Z M2,24 L24,24 L24,2 L2,2 L2,24 Z"
        }, props, {
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({
          d: "M24,0 L24,26 L36,26 C37.104,26 38,25.06816 38,23.92 L38,2.08 C38,0.93184 37.104,0 36,0 L24,0 Z M26,23.8333333 L36,23.8333333 L36,2.16666667 L26,2.16666667 L26,23.8333333 Z"
        }, props, {
          className: "fill"
        }), void 0)]
      }), void 0);

    case '2-col-narrow-l':
      return (0, jsx_runtime_1.jsxs)("g", __assign({
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({
          d: "M14,0 L2,0 C0.896,0 0,0.93184 0,2.08 L0,23.92 C0,25.06816 0.896,26 2,26 L14,26 L14,0 Z M2,24 L12,24 L12,2 L2,2 L2,24 Z"
        }, props, {
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({
          d: "M12,0 L12,26 L36,26 C37.104,26 38,25.06816 38,23.92 L38,2.08 C38,0.93184 37.104,0 36,0 L12,0 Z M14,24 L36,24 L36,2 L14,2 L14,24 Z"
        }, props, {
          className: "fill"
        }), void 0)]
      }), void 0);

    case '2-col-ex-narrow-r':
      return (0, jsx_runtime_1.jsxs)("g", __assign({
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({
          d: "M29,0 L2,0 C0.896,0 0,0.93184 0,2.08 L0,23.92 C0,25.06816 0.896,26 2,26 L29,26 L29,0 Z M2,24 L27,24 L27,2 L2,2 L2,24 Z"
        }, props, {
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({
          d: "M27,0 L27,26 L36,26 C37.104,26 38,25.06816 38,23.92 L38,2.08 C38,0.93184 37.104,0 36,0 L27,0 Z M29,24 L36,24 L36,2 L29,2 L29,24 Z"
        }, props, {
          className: "fill"
        }), void 0)]
      }), void 0);

    case '3-col':
      return (0, jsx_runtime_1.jsxs)("g", __assign({
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({
          d: "M12,26 L26,26 L26,0 L12,0 L12,26 Z M14,24 L24,24 L24,2 L14,2 L14,24 Z"
        }, props, {
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({
          d: "M14,0 L2,0 C0.896,0 0,0.93184 0,2.08 L0,23.92 C0,25.06816 0.896,26 2,26 L14,26 L14,0 Z M2,24 L12,24 L12,2 L2,2 L2,24 Z",
          id: "middle"
        }, props, {
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({
          d: "M24,0 L24,26 L36,26 C37.104,26 38,25.06816 38,23.92 L38,2.08 C38,0.93184 37.104,0 36,0 L24,0 Z M26,24 L36,24 L36,2 L26,2 L26,24 Z"
        }, props, {
          className: "fill"
        }), void 0)]
      }), void 0);

    case '3-stacked-r-col':
      return (0, jsx_runtime_1.jsxs)("g", __assign({
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({
          d: "M20,0 L2,0 C0.896,0 0,0.896 0,2 L0,10 L20,10 L20,0 Z M2,8 L18,8 L18,2 L2,2 L2,8 Z"
        }, props, {
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({
          d: "M20,16 L0,16 L0,24 C0,25.104 0.896,26 2,26 L20,26 L20,16 Z M2,24 L18,24 L18,18 L2,18 L2,24 Z"
        }, props, {
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({
          d: "M0,18 L20,18 L20,8 L0,8 L0,18 Z M2,16 L18,16 L18,10 L2,10 L2,16 Z"
        }, props, {
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({
          d: "M18,0 L18,26 L36,26 C37.104,26 38,25.13984 38,24.08 L38,1.92 C38,0.86016 37.104,0 36,0 L18,0 Z M20,24 L36,24 L36,2 L20,2 L20,24 Z"
        }, props, {
          className: "fill"
        }), void 0)]
      }), void 0);

    case 'stacked-r-col':
      return (0, jsx_runtime_1.jsxs)("g", __assign({
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({
          d: "M18,0 L18,26 L36,26 C37.104,26 38,25.13984 38,24.08 L38,1.92 C38,0.86016 37.104,0 36,0 L18,0 Z M20,24 L36,24 L36,2 L20,2 L20,24 Z"
        }, props, {
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({
          d: "M20,0 L2,0 C0.896,0 0,0.896 0,2 L0,14 L20,14 L20,0 Z M2,12 L18,12 L18,2 L2,2 L2,12 Z"
        }, props, {
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({
          d: "M20,12 L0,12 L0,24 C0,25.104 0.896,26 2,26 L20,26 L20,12 Z M2,24 L18,24 L18,14 L2,14 L2,24 Z"
        }, props, {
          className: "fill"
        }), void 0)]
      }), void 0);

    case 'stacked-narrow-r-col':
      return (0, jsx_runtime_1.jsxs)("g", __assign({
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({
          d: "M26,0 L2,0 C0.896,0 0,0.896 0,2 L0,14 L26,14 L26,0 Z M2,12 L24,12 L24,2 L2,2 L2,12 Z"
        }, props, {
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({
          d: "M26,12 L0,12 L0,24 C0,25.104 0.896,26 2,26 L26,26 L26,12 Z M2,24 L24,24 L24,14 L2,14 L2,24 Z"
        }, props, {
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({
          d: "M24,0 L24,26 L36,26 C37.104,26 38,25.06816 38,23.92 L38,2.08 C38,0.93184 37.104,0 36,0 L24,0 Z M26,24 L36,24 L36,2 L26,2 L26,24 Z"
        }, props, {
          className: "fill"
        }), void 0)]
      }), void 0);

    case 'stacked-2-blk-top':
      return (0, jsx_runtime_1.jsxs)("g", __assign({
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({
          d: "M38,12 L0,12 L0,24 C0,25.104 0.871783784,26 1.94594595,26 L36.0540541,26 C37.1282162,26 38,25.104 38,24 L38,12 Z M2,24 L36,24 L36,14 L2,14 L2,24 Z"
        }, props, {
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({
          d: "M20,0 L2,0 C0.896,0 0,0.896 0,2 L0,14 L20,14 L20,0 Z M2,12 L18,12 L18,2 L2,2 L2,12 Z"
        }, props, {
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({
          d: "M18,0 L18,14 L38,14 L38,2 C38,0.896 37.104,0 36,0 L18,0 Z M20,12 L36,12 L36,2 L20,2 L20,12 Z"
        }, props, {
          className: "fill"
        }), void 0)]
      }), void 0);

    case 'stacked-2-blk-btm':
      return (0, jsx_runtime_1.jsxs)("g", __assign({
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({
          d: "M20,12 L0,12 L0,24 C0,25.104 0.896,26 2,26 L20,26 L20,12 Z M2,24 L18,24 L18,14 L2,14 L2,24 Z"
        }, props, {
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({
          d: "M38,12 L18,12 L18,26 L36,26 C37.104,26 38,25.104 38,24 L38,12 Z M20,24 L36,24 L36,14 L20,14 L20,24 Z"
        }, props, {
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({
          d: "M2.05405405,0 C0.920216216,0 0,0.896 0,2 L0,14 L38,14 L38,2 C38,0.896 37.0797838,0 35.9459459,0 L2.05405405,0 Z M2,12 L36,12 L36,2 L2,2 L2,12 Z"
        }, props, {
          className: "fill"
        }), void 0)]
      }), void 0);

    case 'stacked-m-top':
      return (0, jsx_runtime_1.jsxs)("g", __assign({
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({
          d: "M2.05405405,0 C0.920216216,0 0,0.896 0,2 L0,17 L38,17 L38,2 C38,0.896 37.0797838,0 35.9459459,0 L2.05405405,0 Z M2,15 L36,15 L36,2 L2,2 L2,15 Z"
        }, props, {
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({
          d: "M38,15 L0,15 L0,24 C0,25.104 0.920216216,26 2.05405405,26 L35.9459459,26 C37.0797838,26 38,25.104 38,24 L38,15 Z M2,24 L36,24 L36,17 L2,17 L2,24 Z"
        }, props, {
          className: "fill"
        }), void 0)]
      }), void 0);

    case 'stacked-l-top':
      return (0, jsx_runtime_1.jsxs)("g", __assign({
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({
          d: "M2.05405405,0 C0.920216216,0 0,0.896 0,2 L0,21 L38,21 L38,2 C38,0.896 37.0797838,0 35.9459459,0 L2.05405405,0 Z M2,19 L36,19 L36,2 L2,2 L2,19 Z"
        }, props, {
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({
          d: "M38,19 L0,19 L0,24 C0,25.104 0.920216216,26 2.05405405,26 L35.9459459,26 C37.0797838,26 38,25.104 38,24 L38,19 Z M2,24 L36,24 L36,21 L2,21 L2,24 Z"
        }, props, {
          className: "fill"
        }), void 0)]
      }), void 0);

    case 'stacked-l-btm':
      return (0, jsx_runtime_1.jsxs)("g", __assign({
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({
          d: "M38,5 L0,5 L0,24 C0,25.104 0.871783784,26 1.94594595,26 L36.0540541,26 C37.1282162,26 38,25.104 38,24 L38,5 Z M2,24 L36,24 L36,7 L2,7 L2,24 Z"
        }, props, {
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({
          d: "M1.94594595,0 C0.871783784,0 0,0.896 0,2 L0,7 L38,7 L38,2 C38,0.896 37.1282162,0 36.0540541,0 L1.94594595,0 Z M2,5 L36,5 L36,2 L2,2 L2,5 Z"
        }, props, {
          className: "fill"
        }), void 0)]
      }), void 0);

    case '4-blk-btm':
      return (0, jsx_runtime_1.jsxs)("g", __assign({
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({
          d: "M20,12 L0,12 L0,24 C0,25.104 0.896,26 2,26 L20,26 L20,12 Z M2,24 L18,24 L18,14 L2,14 L2,24 Z"
        }, props, {
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({
          d: "M20,0 L2,0 C0.896,0 0,0.896 0,2 L0,14 L20,14 L20,0 Z M2,12 L18,12 L18,2 L2,2 L2,12 Z"
        }, props, {
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({
          d: "M18,0 L18,14 L38,14 L38,2 C38,0.896 37.104,0 36,0 L18,0 Z M20,12 L36,12 L36,2 L20,2 L20,12 Z"
        }, props, {
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({
          d: "M38,12 L18,12 L18,26 L36,26 C37.104,26 38,25.104 38,24 L38,12 Z M20,24 L36,24 L36,14 L20,14 L20,24 Z"
        }, props, {
          className: "fill"
        }), void 0)]
      }), void 0);

    case '4-blk-narrow-r-btm':
      return (0, jsx_runtime_1.jsxs)("g", __assign({
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({
          d: "M38,12 L24,12 L24,26 L36,26 C37.104,26 38,25.104 38,24 L38,12 Z M26,24 L36,24 L36,14 L26,14 L26,24 Z"
        }, props, {
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({
          d: "M24,0 L24,14 L38,14 L38,2 C38,0.896 37.104,0 36,0 L24,0 Z M26,12 L36,12 L36,2 L26,2 L26,12 Z"
        }, props, {
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({
          d: "M26,12 L0,12 L0,24 C0,25.104 0.896,26 2,26 L26,26 L26,12 Z M2,24 L24,24 L24,14 L2,14 L2,24 Z"
        }, props, {
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({
          d: "M26,0 L2,0 C0.896,0 0,0.896 0,2 L0,14 L26,14 L26,0 Z M2,12 L24,12 L24,2 L2,2 L2,12 Z"
        }, props, {
          className: "fill"
        }), void 0)]
      }), void 0);

    case '6-blk-top':
      return (0, jsx_runtime_1.jsxs)("g", __assign({
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({
          d: "M12,14 L26,14 L26,0 L12,0 L12,14 Z M14,12 L24,12 L24,2 L14,2 L14,12 Z"
        }, props, {
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({
          d: "M14,0 L2,0 C0.896,0 0,0.896 0,2 L0,14 L14,14 L14,0 Z M2,12 L12,12 L12,2 L2,2 L2,12 Z"
        }, props, {
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({
          d: "M14,12 L0,12 L0,24 C0,25.104 0.896,26 2,26 L14,26 L14,12 Z M2,24 L12,24 L12,14 L2,14 L2,24 Z"
        }, props, {
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({
          d: "M12,26 L26,26 L26,12 L12,12 L12,26 Z M14,24 L24,24 L24,14 L14,14 L14,24 Z"
        }, props, {
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({
          d: "M38,12 L24,12 L24,26 L36,26 C37.104,26 38,25.104 38,24 L38,12 Z M26,24 L36,24 L36,14 L26,14 L26,24 Z"
        }, props, {
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({
          d: "M24,0 L24,14 L38,14 L38,2 C38,0.896 37.104,0 36,0 L24,0 Z M26,12 L36,12 L36,2 L26,2 L26,12 Z"
        }, props, {
          className: "fill"
        }), void 0)]
      }), void 0);

    case 'move-down':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          d: "M12,0 C18.6273333,0 24,5.37266667 24,12 C24,18.6273333 18.6273333,24 12,24 C5.37266667,24 0,18.6273333 0,12 C0,5.37266667 5.37266667,0 12,0 Z M8.94266667,9.72406667 C8.42266667,9.20306667 7.57733333,9.20306667 7.05733333,9.72406667 C6.53633333,10.2444 6.53633333,11.0887333 7.05733333,11.6094 L7.05733333,11.6094 L12,16.5524 L16.9426667,11.6094 C17.4636667,11.0887333 17.4636667,10.2444 16.9426667,9.72406667 C16.4226667,9.20306667 15.5773333,9.20306667 15.0573333,9.72406667 L15.0573333,9.72406667 L12,12.7810667 Z",
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          d: "M12,0 C18.6273333,0 24,5.37266667 24,12 C24,18.6273333 18.6273333,24 12,24 C5.37266667,24 0,18.6273333 0,12 C0,5.37266667 5.37266667,0 12,0 Z M12,2.66666667 C6.85366667,2.66666667 2.66666667,6.85366667 2.66666667,12 C2.66666667,17.1463333 6.85366667,21.3333333 12,21.3333333 C17.1463333,21.3333333 21.3333333,17.1463333 21.3333333,12 C21.3333333,6.85366667 17.1463333,2.66666667 12,2.66666667 Z M8.94266667,9.72406667 L12,12.7810667 L15.0573333,9.72406667 C15.5773333,9.20306667 16.4226667,9.20306667 16.9426667,9.72406667 C17.4636667,10.2444 17.4636667,11.0887333 16.9426667,11.6094 L12,16.5524 L7.05733333,11.6094 C6.53633333,11.0887333 6.53633333,10.2444 7.05733333,9.72406667 C7.57733333,9.20306667 8.42266667,9.20306667 8.94266667,9.72406667 Z",
          className: "outline"
        }), void 0)]
      }, void 0);

    case 'move-up':
      return (0, jsx_runtime_1.jsxs)("g", {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          d: "M12,0 C18.6273333,0 24,5.37266667 24,12 C24,18.6273333 18.6273333,24 12,24 C5.37266667,24 0,18.6273333 0,12 C0,5.37266667 5.37266667,0 12,0 Z M12,7.4476 L7.05733333,12.3906 C6.53633333,12.9112667 6.53633333,13.7556 7.05733333,14.2759333 C7.57733333,14.7969333 8.42266667,14.7969333 8.94266667,14.2759333 L8.94266667,14.2759333 L12,11.2189333 L15.0573333,14.2759333 C15.5773333,14.7969333 16.4226667,14.7969333 16.9426667,14.2759333 C17.4636667,13.7556 17.4636667,12.9112667 16.9426667,12.3906 L16.9426667,12.3906 L12,7.4476 Z",
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          d: "M12,0 C18.6273333,0 24,5.37266667 24,12 C24,18.6273333 18.6273333,24 12,24 C5.37266667,24 0,18.6273333 0,12 C0,5.37266667 5.37266667,0 12,0 Z M12,2.66666667 C6.85366667,2.66666667 2.66666667,6.85366667 2.66666667,12 C2.66666667,17.1463333 6.85366667,21.3333333 12,21.3333333 C17.1463333,21.3333333 21.3333333,17.1463333 21.3333333,12 C21.3333333,6.85366667 17.1463333,2.66666667 12,2.66666667 Z M12,7.4476 L16.9426667,12.3906 C17.4636667,12.9112667 17.4636667,13.7556 16.9426667,14.2759333 C16.4226667,14.7969333 15.5773333,14.7969333 15.0573333,14.2759333 L12,11.2189333 L8.94266667,14.2759333 C8.42266667,14.7969333 7.57733333,14.7969333 7.05733333,14.2759333 C6.53633333,13.7556 6.53633333,12.9112667 7.05733333,12.3906 L12,7.4476 Z",
          className: "outline"
        }), void 0)]
      }, void 0);

    case 'box-arrow-up-right':
      return (0, jsx_runtime_1.jsxs)("g", __assign({
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, {
        children: [(0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          d: "M2,3 L6,3 L6,5 L2,5 L2,14 L11,14 L11,10 L13,10 L13,14 C13,14.9458762 12.0919128,15.9083028 11.1366883,15.9938418 L11,16 L2,16 C1.04489524,16 0.0908582451,15.0897773 0.006100966,14.1363971 L0,14 L0,5 C0,4.03757768 0.905640254,3.09019301 1.86297799,3.00605561 L2,3 Z M16,0 L16,7 C16,7.66666667 15.6666667,8 15,8 C14.3333333,8 14,7.66666667 14,7 L14,3.5 L6.5,11 L5,11 L5,9.5 L12.5,2 L9,2 C8.33333333,2 8,1.66666667 8,1 C8,0.333333333 8.33333333,0 9,0 L16,0 Z",
          className: "fill"
        }), void 0), (0, jsx_runtime_1.jsx)("path", __assign({}, props, {
          d: "M2,3 L6,3 L6,5 L2,5 L2,14 L11,14 L11,10 L13,10 L13,14 C13,14.9458762 12.0919128,15.9083028 11.1366883,15.9938418 L11,16 L2,16 C1.04489524,16 0.0908582451,15.0897773 0.006100966,14.1363971 L0,14 L0,5 C0,4.03757768 0.905640254,3.09019301 1.86297799,3.00605561 L2,3 Z M16,0 L16,7 C16,7.66666667 15.6666667,8 15,8 C14.3333333,8 14,7.66666667 14,7 L14,3.5 L6.5,11 L5,11 L5,9.5 L12.5,2 L9,2 C8.33333333,2 8,1.66666667 8,1 C8,0.333333333 8.33333333,0 9,0 L16,0 Z",
          className: "outline"
        }), void 0)]
      }), void 0);

    default:
      return (0, jsx_runtime_1.jsx)("path", {}, void 0);
  }
};

var viewBoxMap = {
  'alert-alt': '0 0 18 17',
  'arrow-up-down': '0 0 24 24',
  'circle-cross': '0 0 24 24',
  'circle-delete': '0 0 24 24',
  collapse: '0 0 24 16',
  'delete-alt': '0 0 72 72',
  'download-alt': '0 0 72 72',
  expand: '0 0 24 16',
  'files-feature': '0 0 72 72',
  grid: '0 0 24 18',
  'grid-view': '0 0 24 18',
  hyperlink: '0 0 24 24',
  link: '0 0 24 24',
  'list-view': '0 0 24 18',
  'placeholder-dnd': '0 0 36 36',
  '1-col-fw': '0 0 37 25',
  '1-col-l': '0 0 37 25',
  '1-col-m': '0 0 37 25',
  '1-col-s': '0 0 37 25',
  '2-col': '0 0 37 25',
  '2-col-text': '0 0 37 25',
  '2-col-narrow-r': '0 0 37 25',
  '2-col-narrow-l': '0 0 37 25',
  '2-col-ex-narrow-r': '0 0 37 25',
  '3-col': '0 0 37 25',
  '3-stacked-r-col': '0 0 37 25',
  'stacked-r-col': '0 0 37 25',
  'stacked-narrow-r-col': '0 0 37 25',
  'stacked-2-blk-top': '0 0 37 25',
  'stacked-2-blk-btm': '0 0 37 25',
  'stacked-m-top': '0 0 37 25',
  'stacked-l-top': '0 0 37 25',
  'stacked-l-btm': '0 0 37 25',
  '4-blk-btm': '0 0 37 25',
  '4-blk-narrow-r-btm': '0 0 37 25',
  '6-blk-top': '0 0 37 25',
  'move-up': '0 0 24 24',
  'move-down': '0 0 24 24',
  'box-arrow-up-right': '0 0 16 16'
};

var getText = function (text) {
  if (!text) {
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}, void 0);
  }

  var textLength = text.length;

  switch (textLength) {
    case 1:
      return (0, jsx_runtime_1.jsx)("text", __assign({
        x: "35%",
        y: "20"
      }, {
        children: text
      }), void 0);

    case 2:
      return (0, jsx_runtime_1.jsx)("text", __assign({
        x: "25%",
        y: "20"
      }, {
        children: text
      }), void 0);

    case 3:
      return (0, jsx_runtime_1.jsx)("text", __assign({
        x: "10%",
        y: "20"
      }, {
        children: text
      }), void 0);

    default:
      return (0, jsx_runtime_1.jsx)("text", __assign({
        x: "5%",
        y: "20",
        lengthAdjust: "spacingAndGlyphs",
        textLength: "90%"
      }, {
        children: text
      }), void 0);
  }
};

var Icon = function (_a) {
  var name = _a.name,
      fill = _a.fill,
      _b = _a.viewBox,
      viewBox = _b === void 0 ? '0 0 32 32' : _b,
      _c = _a.width,
      width = _c === void 0 ? '32' : _c,
      _d = _a.height,
      height = _d === void 0 ? '100%' : _d,
      className = _a.className,
      _e = _a.title,
      title = _e === void 0 ? '' : _e,
      _f = _a.text,
      text = _f === void 0 ? '' : _f,
      props = __rest(_a, ["name", "fill", "viewBox", "width", "height", "className", "title", "text"]);

  return (0, jsx_runtime_1.jsxs)("svg", __assign({
    "aria-label": "" + name,
    height: height,
    viewBox: viewBoxMap[name] ? viewBoxMap[name] : viewBox,
    width: width,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "icon " + (className || 'fill')
  }, props, {
    children: [title && title.length > 0 && (0, jsx_runtime_1.jsx)("title", {
      children: title
    }, void 0), getPath(name, {
      fill: fill
    }), getText(text)]
  }), void 0);
};

exports.default = Icon;